import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import {
  Modal,
  Button,
  Icon,
  Checkbox,
  Label,
  Dropdown,
  TextArea,
  Popup,
  Form,
  Input,
  Loader,
  Message,
  MessageHeader,
  MessageContent,
} from "semantic-ui-react";

import htmlParse from "html-react-parser";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

// component
import CardDrugOrderUX from "./CardDrugOrderUX";
import ModCheckADR from "./ModCheckADR";
import ModCheckDI from "./ModCheckDIUX";
import ModCheckDoctorCertificateUX from "./ModCheckDoctorCertificateUX";
import ModCertificateErrorUX from "./ModCertificateErrorUX";
import ModDrugLabInteraction from "./ModDrugLabInteraction";
import ModDrugInteraction from "./ModDrugInteraction";
import CardDrugClaimQA from "./CardDrugClaimQA";
import ModSolventSelection from "./ModSolventSelection";
import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import ModAuthen from "react-lib/apps/common/ModAuthen";
import ModInfo from "react-lib/apps/common/ModInfo";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import ModConfirmCNMI from "react-lib/apps/common/cnmi/ModConfirm";
import ModPediatricDose from "./ModPediatricDose";
import CardDrugVerbalOrder from "../PTM/CardDrugVerbalOrder";

import SearchBox from "react-lib/appcon/common/SearchBox";
// import { DeleteColumn } from "../DFC/CardDoctorFeeOrderAndCompensation";
import DropDownColumn from "react-lib/appcon/common/DropDownColumn";
import EditorColumn from "react-lib/appcon/common/EditorColumn";
import ModConfirmDelete from "react-lib/apps/common/ModConfirm";
import DeleteColumn from "react-lib/appcon/common/DeleteColumn";
import SnackMessage from "react-lib/apps/common/SnackMessage";
import SubDrugOrderStatusAlert, { QAStatus, TaperPopup } from "./SubDrugOrderStatusAlert";
import CardDrugOrderHistory from "./CardDrugOrderHistory";
import ModReMedicationUX from "./ModReMedicationUX";
import ModRecontinueMed from "./ModRecontinueMed";
import CardDuplicateDrugOrders from "./CardDuplicateDrugOrders";
import CardDuplicateDrugClassificationOrders from "./CardDuplicateDrugClassificationOrders";
import ModDrugAllVerify from "./ModDrugAllVerify";
import ModDrugDuplicateGroup from "./ModDrugDuplicateGroup";
import ModDescriptionUD from "./ModDescriptionUD";
import ModProductPackageAlert from "./ModProductPackageAlert";
import SubDrugNameFormat from "react-lib/apps/HISV3/common/SubDrugNameFormat";

import ModMedReconcileAlert from "react-lib/apps/common/ModMedReconcileAlert";
import ModDrugDispensingOrder from "./ModDrugDispensingOrder";
import PopupEditFrequencyDesc from "./PopupEditFrequencyDesc";
import PopupEditRouteDesc from "./PopupEditRouteDesc";
import CardEditMedOrder, { getPrnOptions, prepareModSolventSelection } from "./CardEditMedOrder";
import ModConfirmEditNote from "./ModConfirmEditNote";

// DFC/CardDoctorFeeOrderAndCompensation'

// Utils
import { formatDate, formatDatetime, isTodayBEString } from "react-lib/utils/dateUtils";

// Interface
import {
  ESTIMATE_MAP,
  CARD_DUPLICATE_REASON,
  CARD_DUPLICATE_CLASSIFICATION_REASON,
  setDrugSolventDetail,
  DRUG_ORDER_TYPE,
  PRIORITY_TYPE,
  getDrugOrderListParams,
  getDrugTypeName,
  getDrugStatusName,
} from "./TPDInterface";

// CONFIG
import config from "config/config";
import ModDrugDisease from "./ModDrugDisease";
import ModDrugOrderTemplate from "./ModDrugOrderTemplate";
import ModDrugFact from "./ModDrugFact";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import ModError from "react-lib/appcon/common/ModInfo";
import { beToAd } from "react-lib/utils/dateUtils";
import { MOD_SOLVENT_SELECTION_ID } from "./ModSolventSelectionInterface";
import { Table } from "react-lib/frameworks/Table";
import { useIntl } from "react-intl";
import formatComma from "react-lib/utils/formatComma";
import ButtonLockDrugOrder from "./ButtonLockDrugOrder";

const API_HOST = `${config.API_HOST}`;
const BYPASS_DOCTOR_CERT_KEYING = true; // Feature 68144
const CARD_DRUG_ORDER_ID: string = "CardDrugOrder";

const CARD_DRUG_ORDER = "CardDrugOrder";
const CARD_REJECT_ORDER = "CardRejectOrder";

const SEMANTIC_COLOR: any[] = [
  "red",
  "orange",
  "yellow",
  "olive",
  "green",
  "teal",
  "blue",
  "violet",
  "purple",
  "pink",
  "brown",
];

const SOLVENT_MODE = {
  ADD_SOLVENT: "ADD_SOLVENT",
  EDIT_SOLVENT: "EDIT_SOLVENT",
};

const CardDrugOrder = (props: any) => {
  const intl = useIntl();
  const [orderTypeTab, setOrderTypeTab] = useState("");
  const [isOutsideDrug, setIsOutsideDrug] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [statusRequested, setStatusRequested] = useState<boolean>(true);
  const [dataChanged, setDataChanged] = useState<boolean>(false);
  const [openModDrugHistory, setOpenModDrugHistory] = useState<boolean>(false);
  const [openModAuthen, setOpenModAuthen] = useState<any>({
    open: false,
    isApproveOrder: false,
  });
  const [openModDispense, setOpenModDispense] = useState<boolean>(false);
  // factsheet
  const [openModFactSheet, setOpenModFactSheet] = useState<boolean>(false);
  const [openCalCulator, setOpenCalculator] = useState<boolean>(false);
  const [modSaveWeightWarn, setModSaveWeightWarn] = useState<boolean>(false);
  const [modPediatricDoseErr, setModPediatricDoseErr] = useState<boolean>(false);
  const [modAgeWarn, setModAgeWarn] = useState<string>("");
  // med reconcile duplicate
  const [modMRDuplicate, setModMRDuplicate] = useState<any>({
    open: false,
    message: "",
  });
  // options
  const [reasonOptions, setReasonOptions] = useState<any>([]);

  const [modPharmaConfirm, setModPharmaConfirm] = useState<any>({
    open: false,
    note: "",
  });
  const [modDrugDesc, setModDrugDesc] = useState<{
    open?: boolean;
    desc?: string;
    index?: number;
  }>({});
  const [modConfirmUnlinkMixture, setModConfirmUnlinkMixture] = useState<Record<
    string,
    any
  > | null>(null);
  const [todayHelper, setTodayHelper] = useState(false);
  const [openModEditDrug, setOpenModEditDrug] = useState<boolean>(false);
  const [price, setPrice] = useState<any>({
    priceNonClaimable: 0,
    priceClaimable: 0,
    priceTotal: 0,
  });

  const filterCreateDateRef = useRef<string>("");
  const isAddingSolventRef = useRef(false);
  const columnRemoveRef = useRef<Record<string, any>>({});
  const drugOrderListParamsRef = useRef<any>(null);

  const ORDER_TYPES: { [key: string]: string } = {
    // OPD
    HOME_OPD: "Home Medication",
    ONE_DOSE_OPD: "One Dose OPD",

    // IPD
    HOME_IPD: "Home Medication",
    ONE_DOSE_IPD: "One Dose IPD ",
    ONE_DAY_IPD: "One Day",
    STAT_IPD: "Stat IPD",

    // OPD , IPD (emr ทั่งสองอัน)
    STAT_OPD: "Stat",
    OPERATING: "OPERATING",

    // Daily Order
    [DRUG_ORDER_TYPE.DAILY]: "Daily Order",
  };

  const VERBAL_ORDER_MAPPED: { [key: string]: string } = {
    DRUG_ORDER_ONE_DOSE__OPD: "ONE_DOSE_OPD",
    DRUG_ORDER_HOME_OPD: "HOME_OPD",
    DRUG_ORDER_HOME_IPD: "HOME_IPD",
    DRUG_ORDER_ONE_DOSE__IPD: "ONE_DOSE_IPD",
    DRUG_ORDER_ONE_DAY: "ONE_DAY_IPD",
    DRUG_ORDER_STAT__OPD: "STAT_OPD",
  };

  const orderType = useMemo(
    () => props.onEvent({ message: "GetDrugOrderType", params: { orderType: orderTypeTab } }),
    [orderTypeTab, props.DrugSelectSequence?.priority]
  );

  // #86245 สั่งยานอก รพ. ได้เฉพาะ Daily Order และ Home Medication
  const showOutsideDrug = useMemo(
    () =>
      orderTypeTab === DRUG_ORDER_TYPE.DAILY ||
      [DRUG_ORDER_TYPE.HOME_OPD, DRUG_ORDER_TYPE.HOME_IPD].includes(orderType),
    [orderType, orderTypeTab]
  );

  useEffect(() => {
    setIsOutsideDrug(false);
  }, [orderTypeTab]);

  /* ------------------------------------------------------ */

  /*                       USE EFFECT                       */

  /* ------------------------------------------------------ */
  useEffect(() => {
    // console.log(" useEffect !!! clear ")
    props.runSequence?.({
      sequence: "DrugSelect",
      restart: true,
      defaultOrderBy: props.defaultOrderBy,
    });

    return () => {
      props.onEvent?.({
        message: "ClearDrugOrderForm",
        params: { hard: true, card: CARD_DRUG_ORDER_ID, orderDiv: null },
      });
      props.setProp("drugVerbalFreeTxt", {
        id: null,
        ref_order: null,
        drugType: "",
        note: "",
      });
    };
  }, []);

  useEffect(() => {
    if (
      props.selectedDrug?.id &&
      isAddingSolventRef.current &&
      props.modSolventSelectionConfig?.showButtonSolvent
    ) {
      isAddingSolventRef.current = false;

      handleOpenModSolventSelection();
    }
  }, [props.modSolventSelectionConfig?.showButtonSolvent, props.selectedDrug?.original]);

  useEffect(() => {
    setReasonOptions(props.masterOptions?.drug_limited_age || []);
  }, [props.masterOptions?.drug_limited_age]);

  useEffect(() => {
    setStatusRequested(props.isCardRejectOrder || props.isEditable);
  }, [props.isEditable]);

  useEffect(() => {
    props.setIsDrugRequested?.(statusRequested);
  }, [statusRequested]);

  useEffect(() => {
    if (props.successMessage?.["CardDrugOrder_CONFIRM"]) {
      setOpenModAuthen({ open: false, isApproveOrder: false });
      props.setProp(`successMessage.${"CardDrugOrder_CONFIRM"}`, null);
    }
  }, [props.successMessage?.["CardDrugOrder_CONFIRM"]]);

  // CardVerbalOrder save drug success refresh page
  // useEffect(() => {
  //   if (props.successMessage?.CardVerbalOrder === "บันทึกสำเร็จ") {
  //     setStatusRequested(false);

  //     const params = {
  //       pk: props.selectedEmr?.id,
  //       orderType,
  //       apiType: "pks",
  //       card: CARD_DRUG_ORDER_ID,
  //       defaultOrderBy: props.defaultOrderBy,
  //     };

  //     props.onEvent({
  //       message: "GetDrugOrderList",
  //       params,
  //     });
  //   }
  // }, [props.successMessage?.CardVerbalOrder]);

  useEffect(() => {
    if (props.buttonLoadCheck?.CardDrugOrder_SAVE === "SUCCESS") {
      if (!props.hiddenDrugList) {
        setStatusRequested(false);
      }
      props.setProp("buttonLoadCheck.CardDrugOrder_SAVE", null);
    }
  }, [props.buttonLoadCheck?.CardDrugOrder_SAVE]);

  useEffect(() => {
    let drugOperatingOrderIdJoin =
      props.preOrderList
        ?.filter((item: any) => item.type === "drugoperatingorder")
        ?.map((item: any) => item.id)
        ?.join(",") || "";

    if (orderType === "OPERATING" && props.preOrderList?.length > 0 && !drugOperatingOrderIdJoin) {
      props.onEvent({
        message: "ClearDrugOperatingOrderList",
        params: {
          orderType: orderType,
          card: CARD_DRUG_ORDER_ID,
        },
      });
    }
  }, [props.selectedAppointment?.id]);

  useEffect(() => {
    props.setProp("orderSpecificType", orderTypeTab);
  }, [orderTypeTab]);

  const handleGetDrugOrderList = useCallback(
    ({ orderDate }: any = {}) => {
      drugOrderListParamsRef.current = null;

      const encounterType = props.selectedEncounter?.type || "";
      const isOpdOrder =
        (orderTypeTab === DRUG_ORDER_TYPE.DAILY && encounterType === "OPD") ||
        ["ONE_DOSE_OPD", "STAT_OPD"].includes(orderTypeTab);
      const hasNoSelectedVerbalOrder =
        Object.keys(props.selectedVerbalDrugOrderWorking || {}).length === 0;
      const hasNoProgressCycle = !props.selectedProgressCycle?.id;
      const isVerbalOrderHidden = props.hideCardDrugVerbalOrder;

      if (
        !orderTypeTab ||
        (isOpdOrder && hasNoSelectedVerbalOrder && hasNoProgressCycle && isVerbalOrderHidden)
      ) {
        return;
      }

      const preOrderList: any[] = props.preOrderList || [];

      let params: any = {
        card: CARD_DRUG_ORDER_ID,
        orderType: orderTypeTab,
      };

      if (orderTypeTab === "OPERATING" && preOrderList.length > 0) {
        const drugOperatingIds = preOrderList
          .filter((item) => item.type === "drugoperatingorder")
          .map((item) => item.id as number)
          .join(",");

        if (!drugOperatingIds) {
          return;
        }

        params = {
          ...params,
          apiType: "pks",
          defaultOrderBy: props.defaultOrderBy,
          pk: drugOperatingIds,
        };
      } else if (props.selectedEmr?.id || props.selectedProgressCycle?.id) {
        params = getDrugOrderListParams({
          ...params,
          django: props.django,
          orderDate,
          selectedEmr: props.selectedEmr,
          selectedEncounter: props.selectedEncounter,
          selectedProgressCycle: props.selectedProgressCycle,
        });
      } else {
        return;
      }

      drugOrderListParamsRef.current = params;

      props.onEvent({
        message: "GetDrugOrderList",
        params,
      });
    },
    [orderTypeTab, props.preOrderList, props.selectedEmr?.id, props.selectedProgressCycle?.id]
  );

  // console.log(" CardDrugORder props.drugOperatingOrderId ",  props.drugOperatingOrderId)
  useEffect(() => {
    const orderDate =
      filterCreateDateRef.current || props.drugOrderEdit?.date || formatDate(moment());

    handleGetDrugOrderList({ orderDate });

    filterCreateDateRef.current = orderDate;
    if (isTodayBEString(orderDate)) {
      setTodayHelper(true);
    } else {
      setTodayHelper(false);
    }
  }, [orderTypeTab, props.preOrderList, props.selectedEmr?.id, props.selectedProgressCycle?.id]);

  useEffect(() => {
    if (
      props.orderTypes?.length &&
      props.orderTypes.length > 0 &&
      !props.orderTypes.includes(orderTypeTab)
    ) {
      const defaultTab = props.onEvent({
        message: "GetDrugOrderDefaultTab",
        params: {
          goToTab: props.goToTab,
          orderType: orderTypeTab,
          orderTypes: props.orderTypes,
        },
      });

      setOrderTypeTab(defaultTab);
    }
  }, []);

  useEffect(() => {
    if (props.orderTypeCardRejectOrder) {
      setOrderTypeTab(props.orderTypeCardRejectOrder);
    }
  }, [props.orderTypeCardRejectOrder]);

  useEffect(() => {
    if (orderTypeTab && props.goToTab) {
      props.setProp("goToTab", "");
    }
  }, [orderTypeTab, props.goToTab]);

  // #useEffect(() => {
  //   const order_specific_type =
  //     props.selectedVerbalDrugOrderWorking?.order_specific_type;
  //   const selectedOrderType = VERBAL_ORDER_MAPPED[order_specific_type];
  //   setOrderType(selectedOrderType);
  // }, [props.selectedVerbalDrugOrderWorking?.order_specific_type]);

  useEffect(() => {
    // เมื่อปิด modal solvent
    if (props.modSolventSelectionConfig?.openModal === false) {
      // check ว่า modal ถูกเปิดจากปุ่ม add solvent, edit solvent
      if (
        props.modSolventSelectionConfig?.admixtureMode === SOLVENT_MODE.ADD_SOLVENT &&
        props.modSolventSelectionConfig?.admixtureSolute
      ) {
        handleAddSolventToOrder();
      } else if (
        props.modSolventSelectionConfig?.admixtureMode === SOLVENT_MODE.EDIT_SOLVENT &&
        props.modSolventSelectionConfig?.admixtureSolute
      ) {
        handleEditSolventToOrder();
      }
      // update dose, unit
      else {
        if (
          parseInt(props.modSolventSelectionConfig?.drug_strength) > 0 &&
          props.modSolventSelectionConfig?.drug_strength_choice
        ) {
          props.onEvent({
            message: "HandleChangeDrugOrderDetail",
            params: {
              key: "drugDose",
              value: props.modSolventSelectionConfig?.drug_strength,
              orderType: orderTypeTab,
              card: CARD_DRUG_ORDER,
            },
          });

          props.onEvent({
            message: "HandleChangeDrugOrderDetail",
            params: {
              key: "selectedDrugUnitId",
              value: props.modSolventSelectionConfig?.drug_strength_choice,
              stateKey: "DrugSelectSequence",
              card: CARD_DRUG_ORDER,
              orderType: orderTypeTab,
            },
          });
        }
      }
    }
  }, [props.modSolventSelectionConfig]);

  useEffect(() => {
    if (props.selectedDivision) {
      props.setProp("drugOrder.order_div", props.selectedDivision?.id);
    }
  }, [props.selectedDivision]);

  const getLabelWithId = useCallback((items: any[], id: number, labelKey: string) => {
    // console.log("getLabelWithId", items, id, labelKey)
    for (const item of items) if (item.value === id) return item[labelKey];
    return "";
  }, []);

  useEffect(() => {
    const initialDrugOrderValues = async () => {
      // const isOneDay =
      //   orderTypeTab === DRUG_ORDER_TYPE.DAILY
      //     ? props.DrugSelectSequence?.priority === PRIORITY_TYPE.ROUTINE
      //     : orderType === "ONE_DAY_IPD";

      // default deration "1" เมื่อ order type one day, one dose
      if (!!props.selectedDrug?.id && ["ONE_DAY_IPD", "ONE_DOSE_OPD"].includes(orderType)) {
        await props.setProp("drugDuration", "1");
      }

      if (
        typeof props.modSolventSelectionConfig?.admixtureIndex !== "number" &&
        !!props.selectedDrug?.id &&
        ["STAT_OPD", "STAT_IPD", "ONE_DOSE_IPD", "ONE_DOSE_OPD"].includes(orderType)
      ) {
        props.setProp("drugQty", "1");
      }

      // calculate qty, duration เมื่อเลือกรายการยา
      if (!!props.selectedDrug?.id && !!orderType) {
        if (typeof props.modSolventSelectionConfig?.admixtureIndex !== "number") {
          props.onEvent({
            message: "HandleChangeDrugOrderDetail",
            params: {
              key: ["selectedDrugFrequencyId", "drugDose"],
              orderType: orderTypeTab,
              card: CARD_DRUG_ORDER,
            },
          });
        }

        // if (!config.HIDE_DOSE_CALCULATOR) {
        //   props.onEvent({
        //     message: "GetPediatricDose",
        //     params: {
        //       action: "LIST",
        //       drugDetail: props.selectedDrug?.original,
        //       card: "ModPediatricDose",
        //     },
        //   });
        // }
      }
    };

    initialDrugOrderValues();
  }, [props.selectedDrug?.id, orderType]);

  console.log("modSaveWeightWarn..........", modSaveWeightWarn);
  useEffect(() => {
    console.log("Got PediatricDose: ", props.pediatricData?.items);
    if (props.pediatricData?.items?.length > 0) {
      let itemWithWeightFactor = props.pediatricData?.items
        ?.filter((item: any) => item.calculation_factor === 1)
        ?.map((item: any) => item.id);

      if (
        itemWithWeightFactor?.length > 0 &&
        props.pediatricData?.items[0].encounter_weight === ""
      ) {
        setModSaveWeightWarn(true);
      }

      if (!props.DrugSelectSequence?.limited_age) {
        let pYear = parseInt(props.pediatricData?.items[0].patient_age_year);
        let pMonth = parseInt(props.pediatricData?.items[0].patient_age_month);
        let patAge = pYear * 12 + pMonth;

        let dMaxYear = parseInt(props.selectedDrug?.original?.maximum_age_year);
        let dMaxMonth = parseInt(props.selectedDrug?.original?.maximum_age_month);
        let dMax = dMaxYear * 12 + dMaxMonth;

        let dMinYear = parseInt(props.selectedDrug?.original?.minimum_age_year);
        let dMinMonth = parseInt(props.selectedDrug?.original?.minimum_age_month);
        let dMin = dMinYear * 12 + dMinMonth;

        if (patAge > dMax) {
          setModAgeWarn("ผู้ป่วยมีอายุมากกว่าช่วงที่กำหนด");
          props.setProp("DrugSelectSequence.limited_age", "H");
        } else if (patAge < dMin) {
          setModAgeWarn("ผู้ป่วยมีอายุต่ำกว่าช่วงที่กำหนด");
          props.setProp("DrugSelectSequence.limited_age", "L");
        } else {
          props.setProp("DrugSelectSequence.limited_age", "");
        }

        console.log("==============================");
        console.log(props.pediatricData);
        console.log("patient age: ", patAge, "month");
        console.log(props.selectedDrug?.original);
        console.log("==============================");
      }
    }
    // return () => {
    //   props.setProp("pediatricData", null);
    // };
  }, [props.pediatricData, props.selectedDrug?.id]);

  const enableCalculatorButton = useMemo(() => {
    if (props.pediatricData?.items?.length > 0) {
      return true;
    } else {
      return false;
    }
  }, [props.pediatricData]);

  // เมื่อมีการกด edit มาจากรายการ drug tab order summary
  useEffect(() => {
    const orders = props.drugOrderList || [];

    console.log("CardDrugOrder useEffect props.drugOrderEdit: ", props.drugOrderEdit);
    if (orders.length && props.drugOrderEdit) {
      const data = orders.find((item: any) => item.id === props.drugOrderEdit.id);
      console.log("CardDrugOrder useEffect data: ", data);

      if (data) {
        const allowEdit = checkAllowEditOrder(data);
        console.log("CardDrugOrder useEffect allowEdit: ", allowEdit);

        props.setProp("drugOrderEdit", null);

        if (allowEdit) {
          console.log("CardDrugOrder useEffect handleSelectRow data:", data);
          handleSelectRow(null, data);
        }
      }
    }
  }, [props.drugOrderList, props.drugOrderEdit]);

  // เมื่อมีการกด Med Icon มาจากรายการ Medreconcile เพื่อเปิด Med Order
  useEffect(() => {
    const orders = props.drugOrderList || [];

    if (orders.length && props.drugOrder && props.drugMedReconcileEditId) {
      const isHasDetail = props.drugOrder.items?.some(
        (drugItems: any) => drugItems?.id === props.drugMedReconcileEditId
      );

      let data = undefined;

      if (isHasDetail) {
        data = orders.find((order: any) => props.drugOrder?.id === order.id);
      }

      if (data) {
        const allowEdit = checkAllowEditOrder(data);
        props.setProp("drugMedReconcileEditId", null);

        if (allowEdit) {
          handleSelectRow(null, data);
        }
      }
    }
  }, [props.drugOrderList, props.drugOrder, props.drugMedReconcileEditId]);

  useEffect(() => {
    let priceNonClaimable = 0;
    let priceClaimable = 0;
    let priceTotal = 0;

    const items: any[] = props.drugOrder?.items || [];

    for (const item of items) {
      const getParseFloat = (key: string) => Number.parseFloat(item?.[`${key}`]) || 0;

      priceNonClaimable += getParseFloat("price_non_claimable");
      priceClaimable += getParseFloat("price_claimable");
      priceTotal += getParseFloat("price_total");
    }

    setPrice({
      priceNonClaimable: priceNonClaimable,
      priceClaimable: priceClaimable,
      priceTotal: priceTotal,
    });
  }, [props.drugOrder]);

  /* ------------------------------------------------------ */

  /*                       USE CALLBACK                       */

  /* ------------------------------------------------------ */

  const handleEditSolventToOrder = useCallback(async () => {
    const { drug, solvent } = getDrugSolventOrderItem(props.DrugSelectSequence);

    await props.onEvent({
      message: "SetDrugOrderItemsData",
      params: {
        index: props.modSolventSelectionConfig.admixtureIndex,
        items: {
          ...solvent,
        },
        orderType: orderTypeTab,
        onSuccess: () => {
          props.onEvent({
            message: "AddToOrder",
            params: {
              card: CARD_DRUG_ORDER_ID,
              drugIndex: props.selectedDrug?.index,
              editItem: {
                ...drug,
              },
              orderType,
            },
          });

          handleClearDrugOrderForm();
        },
      },
    });
  }, [props.DrugSelectSequence, props.modSolventSelectionConfig]);

  const handleCheckHaveQuestion = useCallback(async (data: any, index: number) => {
    console.log("handleCheckHaveQuestion data: ", data);
    console.log("handleCheckHaveQuestion index: ", index);

    await props.setProp("DrugSelectSequence.claimPayloadPriorityType", data.priority);

    let p = {
      estimate: {
        ...data.estimate,
        claim_payload: {
          ...(data.estimate?.claim_payload || {}),
          have_question: true,
        },
      },
      payload: {},
      product: data.product,
    };
    console.log("handleCheckHaveQuestion p: ", p);
    props.onEvent({
      message: "CheckHaveQuestion",
      params: p,
    });
  }, []);

  const handleSaveNote = useCallback(
    (item: any, index: number) => {
      props.onEvent({
        message: "AddToOrder",
        params: {
          editItem: {
            [item.key]: item[item.key],
          },
          drugIndex: index,
          orderType: orderType,
          card: CARD_DRUG_ORDER_ID,
        },
      });
    },
    [orderType]
  );

  const handleSelectRow = useCallback(
    (e: any, data: any) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      const isLocked = data.locker_general_status === "LOCKED";

      console.log("CardDrugOrder handleSelectRow data ", data);
      setStatusRequested(data.status_name === "REQUESTED" && !isLocked);
      setIsOutsideDrug(false);

      props.onEvent({
        message: "SetDrugOrder",
        params: {
          item: data,
          orderType: orderType,
          card: CARD_DRUG_ORDER_ID,
        },
      });
      const order = props.verbalDrugOrderList?.find((item: any) => item.ref_order === data.id);
      if (order) {
        props.setProp("drugVerbalFreeTxt", {
          id: order?.id || null,
          ref_order: order?.ref_order || null,
          drugType: order?.order_specific_type || "",
          note: order?.note || "",
        });
      } else {
        props.setProp("drugVerbalFreeTxt", {
          id: null,
          ref_order: null,
          drugType: "",
          note: "",
        });
      }

      props.setProp("openModPharmacistNote", { open: false, note: "" });
      setDataChanged(false);
    },
    [orderType, props.verbalDrugOrderList]
  );

  // const handleAddSolvent = useCallback(
  //   async (solute: any, index: number) => {
  //     await props.setProp("DrugSelectSequence", solute);

  //     await props.onEvent({
  //       message: "SetModSolventSelectionConfig",
  //       params: {
  //         editable: true,
  //         editableQuantity: true,
  //         openModal: true,
  //         admixtureMode: solute.admixtureMode ?? SOLVENT_MODE.EDIT_SOLVENT,
  //         admixtureSolute: solute,
  //         admixtureIndex: index,
  //         activeButtonSolvent: index !== -1,
  //       },
  //     });

  //     let admixtureOptions: any = {
  //       strength: solute?.dose,
  //       strength_unit: solute?.unit || "",
  //     };
  //     // if (props.drugPermission.config_TPD_ENABLE_IV_COMPATIBLE) {
  //     //   admixtureOptions.strength = solute.dose;
  //     //   admixtureOptions.strength_unit = solute.unit;
  //     // } else {
  //     //   admixtureOptions.soluteQuantity = solute.quantity;
  //     // }

  //     props.onEvent({
  //       message: "initModSolventSelection",
  //       params: {
  //         drugOrderType: DRUG_ORDER_TYPE,
  //         solventId: "",
  //         admixtureOptions: admixtureOptions,
  //       },
  //     });
  //   },
  //   [props.drugPermission]
  // );

  // const checkFrequencyUD = useCallback((options: any[], frequencyId: number) => {
  //   return (
  //     (options || [])
  //       .find((option: any) => option.value === frequencyId)
  //       ?.text?.search(/\(UD\)$/g) >= 0
  //   );
  // }, []);

  const checkAllowEditOrder = useCallback(
    (data: any) => {
      if (data) {
        const notAllowEdit =
          props.isStudentUser &&
          data.order_by === data.approved_by &&
          data.order_by !== data.student;

        return !notAllowEdit;
      }
      return false;
    },
    [props.isStudentUser]
  );

  const handleRefreshDrugList = useCallback((status: string) => {
    props.onEvent({
      message: "RefreshDrugOrderList",
      params: drugOrderListParamsRef.current,
    });

    if (status === "LOCKED") {
      setStatusRequested(false);
    }
  }, []);

  /* ------------------------------------------------------ */

  /*                       USE MEMO                       */

  /* ------------------------------------------------------ */

  const handleOpenModAuthen = () => {
    if (props.isStudentUser) {
      setOpenModAuthen({ open: true, isApproveOrder: true });
    } else {
      handleConfirmOrder({ action: "CONFIRM" });
    }
  };

  const handleApproveOrder = (params: any = {}) => {
    props.onEvent({
      message: "ApproveDrugOrder",
      params: {
        action: "CONFIRM",
        orderType: orderTypeTab,
        cardKey: CARD_DRUG_ORDER,
        approved_by_username: params.approved_by_username,
        approved_by_password: params.approved_by_password,
        isCardRejectOrder: props.isCardRejectOrder,
        orderDate: filterCreateDateRef.current,
      },
    });
  };

  const handleConfirmApprove = (params: any = {}) => {
    props.onEvent({
      message: "ApproveDrugOrder",
      params: {
        ...params,
      },
    });
  };

  const handleEditSolvent = async (solute: any, index: number, priority?: string) => {
    await props.setProp(
      "DrugSelectSequence",
      priority ? { ...solute, priority, prevPriority: props.DrugSelectSequence?.priority } : solute
    );

    const solventConfig = {
      editable: true,
      editableQuantity: true,
      openModal: true,
      admixtureMode: solute.admixtureMode ?? SOLVENT_MODE.EDIT_SOLVENT,
      admixtureSolute: solute,
      admixtureIndex: index,
      activeButtonSolvent: index !== -1,
    };

    await props.onEvent({
      message: "SetModSolventSelectionConfig",
      params: solventConfig,
    });

    const solvent: any = solute;

    // if (solute.admixtureMode === "") {
    //   solvent = solute;
    // } else {
    //   props.drugOrder?.items?.forEach((item: any) => {
    //     if (
    //       item?.drug_admixture_order_key === solute.drug_admixture_order_key &&
    //       item?.is_solvent
    //     ) {
    //       solvent = item;
    //     }
    //   });
    // }

    const admixtureOptions: any = {
      // strength: solute.dose,
      // strength_unit: solute.unit,
      volume: solvent?.solvent_volume || solvent?.volume || "",
      quantity: solvent?.quantity,
      mixture_iv_rate: Number.parseInt(solvent?.mixture_iv_rate),
      mixture_iv_rate_unit: solvent?.mixture_iv_rate_unit || "",
      // solute_rate: solvent?.solute_concentration_rate || "",
      // solvent_rate: solvent?.solvent_concentration_rate || "",
      // concentration_unit: solvent?.drug_concentration_unit || "",
      drug_drip_in: solvent?.drug_drip_in || "",
      drug_drip_in_unit: solvent?.drug_drip_in_unit || "",
      unit: solvent?.unit || "",
      price_unit: solvent?.price_unit || "",
    };

    if (!isAddingSolventRef.current) {
      await props.onEvent({
        message: "initModSolventSelection",
        params: {
          admixtureOptions,
          drugOrderType: null,
          solvent: {
            id: solvent?.product,
            full_name: solvent?.product_name,
            label_name: solvent?.product_name,
          },
        },
      });
    }
  };

  const handleEditDrugAdmixture = (data: Record<string, any>, index: number) => {
    const items = props.drugOrder?.items || [];
    const solvent = items[index + 1]?.is_solvent ? items[index + 1] : null;

    props.setProp("drugSearchText", data.product_name);

    handleEditSolvent(
      {
        ...solvent,
        mixture_iv_rate: data.mixture_iv_rate,
        mixture_iv_rate_unit: data.mixture_iv_rate_unit,
        drug_drip_in: data.drug_drip_in,
        drug_drip_in_unit: data.drug_drip_in_unit,
        admixtureMode: data.admixtureMode ?? null,
      },
      solvent || data.admixtureMode === SOLVENT_MODE.ADD_SOLVENT ? index + 1 : -1
    );

    props.onEvent({
      message: "RunSequence",
      params: {
        sequence: "DrugSelect",
        card: CARD_DRUG_ORDER_ID,
        orderType,
        patient: props.selectedAppointment?.patient,
        selectedDrug: {
          ...data,
          id: data.product,
          default_dosage_unit: data.unit,
          default_frequency: data.frequency,
          default_method: data.method,
          default_route: data.route,
          default_site: data.site,
          default_unit_dose: data.dose,
          default_prn: data.prn,
          default_description: data.description,
          default_quantity: data.quantity,
          default_duration: data.duration,
          default_drug_drip_in: data.drug_drip_in,
          default_drug_drip_in_unit: data.drug_drip_in_unit,
          default_mixture_iv_rate: data.mixture_iv_rate,
          default_mixture_iv_rate_unit: data.mixture_iv_rate_unit,
          priority: data.priority,
          index,
        },
        skipChecking: true,
      },
    });

    setOpenModEditDrug(true);
  };

  const orderName = useMemo(() => {
    const orders = props.drugOrderList || [];
    let name = "";

    if (orderType?.includes("STAT")) {
      name = "STAT";
    } else if (orderType?.includes("ONE_DOSE")) {
      name = "ONE DOSE";
    } else if (orderType?.includes("HOME")) {
      name = "HOME";
    } else if (orderType?.includes("ONE_DAY")) {
      name = "ONE DAY";
    } else if (orderType?.includes("OPERATING")) {
      name = "OPERATING";
    }

    const code = orders.find((item: any) => item.id === props.drugOrder?.id)?.code || "-";

    return code === "-" ? "" : `${name} : ${code}`;
  }, [orderType, props.drugOrderList, props.drugOrder]);

  const selectedVerbalDrugOrder = useMemo(() => {
    const order = props.verbalDrugOrderList?.find(
      (item: any) => item.ref_order === props.drugOrder?.id
    );

    if (order) {
      props.setProp("drugVerbalFreeTxt", {
        id: order?.id || null,
        ref_order: order?.ref_order || null,
        drugType: order?.order_specific_type || "",
        note: order?.note || "",
      });
    } else {
      props.setProp("drugVerbalFreeTxt", {
        id: null,
        ref_order: null,
        drugType: "",
        note: "",
      });
    }

    return order;
  }, [props.drugOrder?.id, props.verbalDrugOrderList]);

  // const drugSearchResult = useMemo(() => {
  //   return (props.drugSearchResult || []).map((item: any) => ({
  //     ...item,
  //     generic_name: <div dangerouslySetInnerHTML={{ __html: item.generic_name || "" }} />,
  //   }));
  // }, [props.drugSearchResult]);

  const getNotEnoughStockError = useCallback(
    (error: any) => {
      const drugOrderItems: Record<string, any>[] = props.drugOrder?.items || [];
      const errors = Array.isArray(error) ? error[0] : error;
      const isNotEnoughStock = errors?.items?.[0]?.detail === "Not enough stock";

      if (isNotEnoughStock) {
        const { storage } = errors.items[0];
        const storageName =
          props.masterOptions?.storage?.find(
            (option: Record<string, any>) => option.value === Number(storage)
          )?.text || "";

        return {
          header: (
            <p style={{ textAlign: "center", fontWeight: "normal" }}>
              <strong>{intl.formatMessage({ id: "ไม่พบรายการสินค้าในคลัง" })}</strong>{" "}
              กรุณาเติมสินค้าไปยัง <strong>{storageName}</strong>
            </p>
          ),
          error: errors.items.map((item: Record<string, any>) => {
            const productName =
              drugOrderItems.find((drug) => drug.product === Number(item.product))?.product_name ||
              "";

            return `<b>[${item.product_code}]</b> ${productName}`;
          }),
        };
      }

      return null;
    },
    [props.drugOrder, props.masterOptions]
  );

  const drugOrderErrorMessage = useMemo(() => {
    console.log("props.errorMessage ", props.errorMessage);
    if (props.errorMessage?.ModPediatricDose?.error) {
      setModPediatricDoseErr(true);
    }

    const error =
      typeof props.errorMessage?.[CARD_DRUG_ORDER]?.showMessage === "undefined"
        ? props.errorMessage?.[CARD_DRUG_ORDER]?.error
        : props.errorMessage?.[CARD_DRUG_ORDER]?.showMessage &&
          props.errorMessage?.[CARD_DRUG_ORDER]?.error;

    return getNotEnoughStockError(error) || { header: null, error };
  }, [props.errorMessage, getNotEnoughStockError]);

  const duplicateReasonErrorMessage = useMemo(() => {
    const error = props.errorMessage?.[CARD_DUPLICATE_REASON]?.error;

    const lockerError =
      error?.[0]?.__error_type__?.[0] === "EDITING_LOCKED"
        ? { header: null, error: error?.[0]?.message }
        : null;

    return getNotEnoughStockError(error) || lockerError || { header: null, error };
  }, [props.errorMessage, getNotEnoughStockError]);

  const divisionOptions = useMemo(() => {
    return props.divisionForOrderDivOptions || [];
  }, [props.divisionForOrderDivOptions]);

  const renderDrugOrderItems = useMemo(() => {
    // console.log("  renderDrugOrderItems props.drugOrder: ", props.drugOrder);
    // console.log("  renderDrugOrderItems props.drugOrder?.items: ", props.drugOrder?.items);
    // console.log("  renderDrugOrderItems DrugSelectSequence", props.DrugSelectSequence);
    let items: any[] = props.drugOrder?.items || [];
    let admixtureKeyMapper: any = {};
    props.drugOrder?.items?.forEach((item: any) => {
      if (item?.drug_admixture_order_key) {
        let admixtureItem = props.drugOrder?.items.filter(
          (admixture: any) => admixture.drug_admixture_order_key === item.drug_admixture_order_key
        );

        if (admixtureItem?.length > 1) {
          if (admixtureKeyMapper?.[item?.drug_admixture_order_key]) {
          } else {
            admixtureKeyMapper[item?.drug_admixture_order_key] =
              Object.keys(admixtureKeyMapper).length + 1;
          }
        }
      }
    });

    const data = props.drugOrderItemMasterData || {};

    return items.map((item: any, index: number) => {
      let quantity = item.quantity;

      if (item.is_dispensed) {
        quantity = parseFloat(item.dose) / parseFloat(item.total_dispense_unit);
      }

      const isNextItemSolvent = items[index + 1]?.is_solvent;
      const isDrugAdmixture = !!item.drug_admixture_order_key && isNextItemSolvent;
      const readOnly = isDrugAdmixture || item.is_solvent;
      // const readOnly = true;
      const isAddSolvent = !isNextItemSolvent && item.is_intravaneous;

      const route = getLabelWithId(
        props.drugOrderItemMasterData?.masterRoutes || [],
        item.route,
        "text"
      );
      const mixtureIvRateUnit = getLabelWithId(
        props.masterOptions?.unit || [],
        item.mixture_iv_rate_unit,
        "text"
      );
      const drugDripInUnit = getLabelWithId(
        props.masterOptions?.unit || [],
        item.drug_drip_in_unit,
        "text"
      );

      const prnOptions = getPrnOptions(props.masterOptions?.prn, item.prn);

      const targetOrderType = props.onEvent({
        message: "GetDrugOrderType",
        params: { orderType: orderTypeTab, priority: item.priority },
      });

      return {
        ...item,
        isDrugAdmixture,
        isNextItemSolvent,
        title_status: (
          <>
            {props.isCardRejectOrder && item.rejected ? (
              <div
                style={{
                  backgroundColor: "rgba(219, 40, 40, 0.2)",
                  fontSize: "1.3em",
                }}
              >
                <strong>Rejected:</strong> {item.note_rejected}
              </div>
            ) : null}
            <div>
              <label style={{ marginRight: "1rem" }}>
                <div style={{ fontWeight: "lighter" }}>
                  <SubDrugNameFormat
                    onEvent={props.onEvent}
                    name={item.drug_name_from_format || item.product_name}
                    product={item.product}
                  />
                </div>
                {item?.individual_use && (
                  <label style={{ color: "red", fontSize: "12px", paddingLeft: "10px" }}>
                    {intl.formatMessage({ id: "(ยาสำหรับผู้ป่วยเฉพาะราย)" })}
                  </label>
                )}
              </label>
              {item.mr_duplicate && (
                <Button
                  color="yellow"
                  content="MR"
                  style={{ padding: "0.35rem 0.55rem", fontSize: "0.85rem" }}
                  onClick={() => {
                    setModMRDuplicate({ open: true, message: item.mr_message });
                  }}
                />
              )}
              {/* {checkFrequencyUD(
                props.selectedDrugItemDetailOptions?.frequency ||
                  props.drugOrderItemMasterData?.masterFrequencies,
                item.frequency
              ) && (
                <Button
                  icon="clipboard list"
                  circular={true}
                  color="green"
                  style={{
                    padding: "0.4rem 0.45rem 0.45rem",
                    fontSize: "1rem",
                  }}
                  onClick={() =>
                    setModDrugDesc({
                      open: true,
                      desc: item.description,
                      index,
                    })
                  }
                />
              )} */}
            </div>
            <SubDrugOrderStatusAlert
              onEvent={props.onEvent}
              stateKey="drugOrder"
              index={index}
              item={{
                ...item,
                alerts: {
                  H: item?.highalert === "True",
                  L: item?.lasa === "True",
                  I:
                    item?.drug_interaction_info || item?.note_drug_interaction
                      ? {
                          info: item.drug_interaction_info || item.note_drug_interaction,
                        }
                      : null,
                  ...(item.alerts || {}),
                  ...(item?.duplicateReason?.code === "DUPLICATE_DRUG_GROUP" && {
                    D: {
                      details:
                        item?.duplicateReason?.duplicate_list?.find(
                          (d: any) => d.product === item.product
                        )?.duplicated_detail +
                        `<div> <br/> <span style="color: red; font-weight: bolder"> เหตุผลที่สั่งยาซ้ำ: </span> ${item.note_group_duplicated} </div>`,
                    },
                  }),
                },
                claim_payload: item.estimate?.claim_payload ? item.estimate?.claim_payload : null,
              }}
              saveClaimByEvent={true}
              estimate={props.drugOrder?.estimate || {}}
              selectedEncounter={props.selectedEncounter}
              selectedEmr={props.selectedEmr}
              orderType={orderType}
              selectedProgressCycle={props.selectedProgressCycle}
              isFemale={props.selectedEncounter?.patient_gender_name === "Female"}
              statusRequest={!statusRequested}
              onSaveNote={handleSaveNote}
              // callback
              onDrugClaim={() => handleCheckHaveQuestion(item, index)}
              targetStateOrder={"drugOrder"}
              style={{ width: "50%" }}
              languageUX={props.languageUX}
            />
          </>
        ),
        dose: (
          <EditorColumn
            value={
              item.is_solvent ? Number(item.solvent_volume || item.volume) || "" : item?.dose || ""
            }
            disabled={!statusRequested || readOnly}
            onDataChanged={(value: string) => {
              props.onEvent({
                message: "AddToOrder",
                params: {
                  editItem: { dose: value },
                  drugIndex: index,
                  orderType: targetOrderType,
                  card: CARD_DRUG_ORDER_ID,
                },
              });
              setDataChanged(true);
            }}
          />
        ),
        unit: (
          <DropDownColumn
            showText={getLabelWithId(
              props.drugOrderItemMasterData?.masterUnits || [],
              item.unit,
              "text"
            )}
            options={
              props.selectedDrugItemDetailOptions?.unit ||
              props.drugOrderItemMasterData?.masterUnits ||
              []
            }
            value={item.unit}
            readOnly={!statusRequested || readOnly}
            backgroundColor={readOnly ? "" : undefined}
            onDataChanged={(value: string) => {
              props.onEvent({
                message: "AddToOrder",
                params: {
                  editItem: { unit: value },
                  drugIndex: index,
                  orderType: targetOrderType,
                  card: CARD_DRUG_ORDER_ID,
                },
              });
              setDataChanged(true);
            }}
          />
        ),
        route: isDrugAdmixture ? (
          <div>
            {route}
            {!!Number(item.mixture_iv_rate) && (
              <div>
                Drip Rate : {Number(item.mixture_iv_rate)} {mixtureIvRateUnit}
              </div>
            )}
            {!!Number(item.drug_drip_in) && (
              <div>
                Drip Duration : {Number(item.drug_drip_in)} {drugDripInUnit}
              </div>
            )}
          </div>
        ) : item.is_solvent ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "98%",
              ...(item.priority === PRIORITY_TYPE.STAT &&
                orderTypeTab === DRUG_ORDER_TYPE.DAILY && { color: "red", fontWeight: "bold" }),
            }}
          >
            สำหรับผสม {items[index - 1]?.product_name}
          </div>
        ) : (
          // <DropDownColumn
          //   showText={route}
          //   options={
          //     props.selectedDrugItemDetailOptions?.route ||
          //     props.drugOrderItemMasterData?.masterRoutes ||
          //     []
          //   }
          //   value={item.route || ""}
          //   readOnly={!statusRequested || readOnly}
          //   backgroundColor={readOnly ? "" : undefined}
          //   onDataChanged={(value: string) => {
          //     props.onEvent({
          //       message: "AddToOrder",
          //       params: {
          //         editItem: { route: value },
          //         drugIndex: index,
          //         orderType: orderType,
          //         card: CARD_DRUG_ORDER_ID,
          //       },
          //     });
          //     setDataChanged(true);
          //   }}
          // />
          <PopupEditRouteDesc
            onEvent={props.onEvent}
            setProp={props.setProp}
            options={
              props.selectedDrugItemDetailOptions?.route ||
              props.drugOrderItemMasterData?.masterRoutes ||
              []
            }
            data={item}
            drugPermission={props.drugPermission}
            masterData={props.masterData}
            modSolventSelectionConfig={props.modSolventSelectionConfig}
            disabled={!statusRequested || readOnly}
            backgroundColor={isDrugAdmixture || readOnly ? "" : undefined}
            // backgroundColor={""}
            orderType={orderType}
            onSave={(value) => {
              props.onEvent({
                message: "AddToOrder",
                params: {
                  editItem: value,
                  drugIndex: index,
                  orderType: targetOrderType,
                  card: CARD_DRUG_ORDER_ID,
                },
              });
              setDataChanged(true);
            }}
            onEditSolvent={async (solute: any, index: number) => {
              handleEditSolvent(solute, index, item.priority);
            }}
            onClose={async () => {
              handleClearDrugOrderForm();
            }}
          >
            <div>
              <div>{getLabelWithId(data.masterRoutes || [], item.route, "text")}</div>
              {!!Number(item.mixture_iv_rate) && (
                <>
                  <div>
                    Drip Rate : {Number(item.mixture_iv_rate)} {mixtureIvRateUnit}
                  </div>
                </>
              )}
              {!!Number(item.drug_drip_in) && (
                <>
                  <div>
                    Drip Duration : {Number(item.drug_drip_in)} {drugDripInUnit}
                  </div>
                </>
              )}
            </div>
          </PopupEditRouteDesc>
        ),
        site: (
          <DropDownColumn
            showText={getLabelWithId(data.masterSites || [], item.site, "text")}
            options={
              props.selectedDrugItemDetailOptions?.site ||
              props.drugOrderItemMasterData?.masterSites ||
              []
            }
            value={item.site || ""}
            readOnly={!statusRequested || readOnly}
            backgroundColor={readOnly ? "" : undefined}
            onDataChanged={(value: string) => {
              props.onEvent({
                message: "AddToOrder",
                params: {
                  editItem: { site: value },
                  drugIndex: index,
                  orderType: targetOrderType,
                  card: CARD_DRUG_ORDER_ID,
                },
              });
              setDataChanged(true);
            }}
          />
        ),
        frequency: (
          // <DropDownColumn
          //   showText={getLabelWithId(data.masterFrequencies || [], item.frequency, "text")}
          //   options={
          //     props.selectedDrugItemDetailOptions?.frequency ||
          //     props.drugOrderItemMasterData?.masterFrequencies ||
          //     []
          //   }
          //   value={item.frequency || ""}
          //   readOnly={!statusRequested}
          //   onDataChanged={(value: string) => {
          //     props.onEvent({
          //       message: "AddToOrder",
          //       params: {
          //         editItem: { frequency: value, description: "" },
          //         drugIndex: index,
          //         orderType: orderType,
          //         card: CARD_DRUG_ORDER_ID,
          //       },
          //     });
          //     setDataChanged(true);
          //   }}
          // />
          <PopupEditFrequencyDesc
            options={
              props.selectedDrugItemDetailOptions?.frequency ||
              props.drugOrderItemMasterData?.masterFrequencies ||
              []
            }
            description={item.description}
            frequency={item.frequency}
            disabled={!statusRequested || readOnly}
            backgroundColor={isDrugAdmixture || readOnly ? "" : undefined}
            // backgroundColor={""}
            onSave={(value) => {
              props.onEvent({
                message: "AddToOrder",
                params: {
                  editItem: value,
                  drugIndex: index,
                  orderType: targetOrderType,
                  card: CARD_DRUG_ORDER_ID,
                },
              });
              setDataChanged(true);
            }}
          >
            <div>
              <div>{getLabelWithId(data.masterFrequencies || [], item.frequency, "text")}</div>
              <div>{item.description}</div>
            </div>
          </PopupEditFrequencyDesc>
        ),
        // method: (
        //   <DropDownColumn
        //     showText={getLabelWithId(
        //       props.drugOrderItemMasterData?.masterMethods || [],
        //       item.method,
        //       "text"
        //     )}
        //     options={
        //       props.selectedDrugItemDetailOptions?.method ||
        //       props.drugOrderItemMasterData?.masterMethods ||
        //       []
        //     }
        //     value={item.method || ""}
        //     readOnly={!statusRequested}
        //     onDataChanged={(value: string) => {
        //       props.onEvent({
        //         message: "AddToOrder",
        //         params: {
        //           editItem: { method: value },
        //           drugIndex: index,
        //           orderType: orderType,
        //           card: CARD_DRUG_ORDER_ID,
        //         },
        //       });
        //       setDataChanged(true);
        //     }}
        //   />
        // ),
        prn: (
          <DropDownColumn
            options={[...new Map(prnOptions.map((item) => [item.value, item])).values()]}
            value={item.prn || ""}
            allowAdditions={true}
            readOnly={!statusRequested || readOnly}
            backgroundColor={readOnly ? "" : undefined}
            clearable={true}
            onDataChanged={(value: string) => {
              props.onEvent({
                message: "AddToOrder",
                params: {
                  editItem: { prn: value },
                  drugIndex: index,
                  orderType: targetOrderType,
                  card: CARD_DRUG_ORDER_ID,
                },
              });
              setDataChanged(true);
            }}
          />
        ),
        quantity: (
          <EditorColumn
            value={quantity || ""}
            disabled={!statusRequested || readOnly || item.is_dispensed}
            inputMin={0}
            onDataChanged={(value: string) => {
              let valueNumber = Number(value);
              if (value === "" || isNaN(valueNumber)) {
                return;
              }
              if (valueNumber >= 0) {
                props.onEvent({
                  message: "HandleChangeEditValueDrug",
                  params: {
                    drugIndex: index,
                    orderType: orderTypeTab,
                    card: CARD_DRUG_ORDER_ID,
                    key: "quantity",
                    value,
                    original: item,
                  },
                });
                setDataChanged(true);
              }
            }}
          />
        ),
        duration: (
          <EditorColumn
            value={item.duration || ""}
            disabled={!statusRequested || readOnly}
            inputMin={0}
            onDataChanged={(value: string) => {
              let valueNumber = Number(value);
              if (value === "" || isNaN(valueNumber)) {
                return;
              }
              if (valueNumber >= 0) {
                props.onEvent({
                  message: "HandleChangeEditValueDrug",
                  params: {
                    // editItem: { duration: valueNumber },
                    drugIndex: index,
                    orderType: orderTypeTab,
                    card: CARD_DRUG_ORDER_ID,
                    key: "duration",
                    value: valueNumber,
                    original: item,
                  },
                });
                setDataChanged(true);
              }
            }}
          />
        ),
        _remove: (
          <div
            ref={(ref) => {
              if (ref) {
                columnRemoveRef.current[item.product] = ref;
              }
            }}
            style={
              {
                position: "absolute",
                display: "flex",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                flexDirection: "column",
                alignItems: "center",
                top: 0,
                // zIndex: readOnly ? -1 : 1,
              }
              // ...(item.isDrugAdmixture && { bottom: "-15px", zIndex: "1" }),
            }
          >
            {/* {admixtureKeyMapper?.[item?.drug_admixture_order_key] && (
              <Label
                circular
                color={SEMANTIC_COLOR[admixtureKeyMapper[item?.drug_admixture_order_key]]}
              >
                {admixtureKeyMapper[item?.drug_admixture_order_key]}
              </Label>
            )} */}
            {/*<Icon
              name="chain"
              size="large"
              disabled={!statusRequested}
              style={{
                cursor: "pointer",
                display:
                  !!item?.is_solvent ||
                  (!!item?.drug_admixture_order_key &&
                    props.drugOrder?.items?.filter(
                      (d: any) => d?.drug_admixture_order_key === item?.drug_admixture_order_key
                    ).length > 1) ||
                  !item?.is_intravaneous
                    ? "none"
                    : "",
              }}
              onClick={() => {
                handleAddSolvent(item, index);
              }}
            />*/}
            {/* <Icon
              name="flask"
              size="large"
              disabled={!statusRequested}
              style={{
                cursor: "pointer",
                display:
                  !props.drugPermission?.config_TPD_ENABLE_IV_COMPATIBLE ||
                  !!item?.is_solvent ||
                  !item?.drug_admixture_order_key ||
                  props.drugOrder?.items?.filter(
                    (d: any) => d?.drug_admixture_order_key === item?.drug_admixture_order_key
                  ).length === 1
                    ? "none"
                    : "",
              }}
              onClick={() => {
                handleEditSolvent(item, index);
              }}
            /> */}
            {/* <Icon
              name="broken chain"
              size="large"
              disabled={!statusRequested}
              style={{
                cursor: "pointer",
                display:
                  item.drug_admixture_order_key &&
                  props.drugOrder?.items?.filter(
                    (d: any) => d?.drug_admixture_order_key === item?.drug_admixture_order_key
                  ).length > 1
                    ? ""
                    : "none",
              }}
              onClick={() => {
                props.onEvent({
                  message: "HandleOnRemoveDrug",
                  params: {
                    action: "unlink_mixture",
                    removeAdmixtureKey: item.drug_admixture_order_key,
                    card: CARD_DRUG_ORDER_ID,
                  },
                });
              }}
            /> */}

            {!item.is_solvent && (
              <Icon
                name="edit outline"
                size="large"
                color="yellow"
                disabled={!statusRequested}
                style={{ cursor: "pointer", margin: "0px -1rem 0.85rem" }}
                onClick={(e) => {
                  e.stopPropagation();

                  handleEditDrugAdmixture(item, index);
                }}
              />
            )}

            {!item.is_solvent && (
              <Icon
                name="trash alternate outline"
                size="large"
                color="red"
                disabled={!statusRequested}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  props.onEvent({
                    message: "HandleOnRemoveDrug",
                    params: {
                      action: "need_confirm",
                      removeDrugId: item.product || null,
                      drugIndex: index,
                      card: CARD_DRUG_ORDER_ID,
                    },
                  });
                  setDataChanged(true);
                }}
              />
            )}

            {(isAddSolvent || isDrugAdmixture) && (
              <Icon.Group
                size="large"
                style={{ marginTop: "0.85rem", cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();

                  if (isDrugAdmixture) {
                    setModConfirmUnlinkMixture(item);

                    return;
                  }

                  isAddingSolventRef.current = true;

                  handleEditDrugAdmixture(
                    { ...item, admixtureMode: SOLVENT_MODE.ADD_SOLVENT },
                    index
                  );
                }}
              >
                <Icon name="lab" style={{ color: isDrugAdmixture ? "#ff8d3a" : "#0072bc" }} />
                <Icon
                  name={isDrugAdmixture ? "remove circle" : "add circle"}
                  corner
                  color={isDrugAdmixture ? "red" : "green"}
                />
              </Icon.Group>
            )}
          </div>
        ),
        price_unit: (
          <div style={{ textAlign: "end" }}>
            {Number(item.price_unit || "").toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        ),
        price_total: (
          <div style={{ textAlign: "end" }}>
            {Number(item.price_total || "").toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        ),
        price_claimable: (
          <div style={{ textAlign: "end" }}>
            {Number(item.price_claimable || "").toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        ),
        price_non_claimable: (
          <div style={{ textAlign: "end" }}>
            {Number(item.price_non_claimable || "").toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        ),

        // unitText: getLabelWithId(data.masterUnits || [], item.unit, "text"),
        // routeText: getLabelWithId(data.masterRoutes || [], item.route, "text"),
        // siteText: getLabelWithId(data.masterSites || [], item.site, "text"),
        // frequencyText:
        // methodText: getLabelWithId(data.masterMethods || [], item.method, "text"),
      };
    });
  }, [
    props.drugOrder,
    props.drugOrderItemMasterData,
    props.selectedEncounter,
    props.selectedEmr,
    props.selectedProgressCycle,
    orderType,
    orderTypeTab,
    props.masterOptions,
    props.modSolventSelectionConfig,
    props.masterData,
    props.drugPermission,
  ]);

  // const drugOrderTemplateList = useMemo(() => {
  //   return (props.modDrugOrderTemplate?.drugOrderTemplateList || []).map(
  //     (item: any) => ({
  //       ...item,
  //       _checkbox: (
  //         <Checkbox
  //           checked={props.modDrugOrderTemplate?.selectedDrugOrderTemplates?.includes(
  //             item.id
  //           )}
  //           onChange={(e: any, { v }) => {
  //             props.onEvent({
  //               message: "HandleDrugOrderTemplate",
  //               params: {
  //                 action: "select_drug_order",
  //                 selectedDrugOrder: item.id,
  //                 card: CARD_DRUG_ORDER_ID,
  //               },
  //             });
  //           }}
  //         />
  //       ),
  //       name: (
  //         <div
  //           style={{ height: "100%", width: "100%" }}
  //           onClick={(e: any) => {
  //             props.onEvent({
  //               message: "HandleDrugOrderTemplate",
  //               params: {
  //                 action: "show",
  //                 selectedDrugOrder: item?.id || null,
  //               },
  //             });
  //           }}
  //         >
  //           {item?.name}
  //         </div>
  //       ),
  //     })
  //   );
  // }, [props.modDrugOrderTemplate]);

  const findDoctor = (order_by: number) => {
    let doctor = props.masterOptions?.doctor?.find((data: any) => data.value === order_by);

    let doctorName = doctor?.text.split("(");
    return doctorName?.[0] || doctor;
  };

  const drugOrderList = useMemo(() => {
    return (props.drugOrderList || []).map((item: any) => {
      let hideActionMenu: boolean = true;

      const rolesTypes: string[] = props.django?.user?.role_types || [];
      const isPharmacy = rolesTypes.includes("PHARMACIST");
      const isDoctor = rolesTypes.includes("DOCTOR");
      const isNurse = rolesTypes.includes("REGISTERED_NURSE");
      const isLocked = item.locker_general_status === "LOCKED";

      if (isPharmacy || isDoctor) {
        hideActionMenu = false;
      } else if (item?.order_type_name !== "DIRECT" && isNurse && !item?.order_approve_time) {
        hideActionMenu = false;
      }

      const isStudent =
      props.isStudentUser && item.order_by === item.approved_by && item.order_by !== item.student;

            const isCancel = item.can_cancel && !hideActionMenu;

      const canDelete = (isStudent || isCancel) && !isLocked;

      return {
        ...item,
        code: (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>{item.code}</div>
              <div
                style={{
                  backgroundColor: "red",
                  borderRadius: "50%",
                  width: "1em",
                  height: "1em",
                  margin: "0px 5px",
                  ...(!(item?.need_approve && item?.student_name) && {
                    display: "none",
                  }),
                }}
              />
            </div>
            {item?.order_type_name !== "DIRECT" && !item?.order_approve_time && (
              <Popup
                trigger={
                  <Label color="orange" size="tiny">
                    รคส.
                  </Label>
                }
                content={
                  <>
                    <strong>ผู้บันทึกรับคำสั่ง</strong>
                    <br />
                    {item?.order_receive_by_name}
                  </>
                }
              ></Popup>
            )}
            {item?.order_type_name !== "DIRECT" && item?.order_approve_time && (
              <Popup
                trigger={
                  <Label color="green" size="tiny">
                    รคส. (co-signed)
                  </Label>
                }
                content={
                  <>
                    <strong>ผู้บันทึกรับคำสั่ง</strong>
                    <br />
                    {item?.order_receive_by_name}
                  </>
                }
              ></Popup>
            )}
          </div>
        ),
        created: formatDatetime(item.created),
        summary: (
          <div>
            <SubDrugNameFormat
              onEvent={props.onEvent}
              summary={item.summary_with_name_format}
              status={item.status_name}
              showDrugInsufficient={item.show_drug_insufficient_icon}
            />
            {/* <Popup
              content={<TaperPopup />}
              on="click"
              position="bottom left"
              pinned
              trigger={

              }
            /> */}
            {/* <img
            src={"/static/images/taper-schedule.png"}
            style={{
              width: "1.5rem",
              cursor: "pointer",
              margin: "0px 0.142857em",
            }}
            alt="taper-schedule.icon"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                /> */}
          </div>
        ),
        careprovider: item?.status_name !== "CANCELED" && (
          <div>
            {item?.order_by === item?.approved_by ? (
              <div style={{ display: "flex", justifyContent: "center" }}>{item?.order_by_name}</div>
            ) : (
              <div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {findDoctor(item?.order_by)}
                </div>
                {item?.need_approve && item?.student_name ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "5px 0px",
                    }}
                  >
                    <ButtonLoadCheck
                      // function
                      id="btn-confirmMedOrder"
                      setProp={props.setProp}
                      onClick={(e: any) => {
                        e.stopPropagation();

                        props.setProp("OrderCentralLabSequence.orderId", item?.id);

                        let fullNameSplit = props.django?.user?.full_name.split(" ");

                        if (
                          props.selectedEmr?.doctor_name ===
                            `${fullNameSplit?.[0]}${fullNameSplit?.[1]} ${fullNameSplit?.[2]}` &&
                          item?.student_name
                        ) {
                          handleConfirmApprove({
                            action: "education_approve",
                            approved_by_username: "",
                            approved_by_password: "",
                            orderId: item?.id,
                            orderType: orderType,
                          });
                        } else {
                          setOpenModAuthen({ open: true, isApproveOrder: true });
                        }
                      }}
                      // data
                      paramKey={`${CARD_DRUG_ORDER}_CONFIRM_${item?.id}`}
                      buttonLoadCheck={
                        props.buttonLoadCheck?.[`${CARD_DRUG_ORDER}_CONFIRM_${item?.id}`]
                      }
                      // config
                      color={"green"}
                      title={
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src="/static/images/drugOrder/doctor_approve.png"
                            style={{ width: "15px", marginRight: "7px" }}
                          ></img>
                          <label>APPROVE</label>
                        </div>
                      }
                      style={{
                        borderRadius: "5px",
                        padding: "0.25rem 1rem",
                        fontSize: "0.75rem",
                      }}
                    />
                  </div>
                ) : (
                  item?.student_name && (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "20px 0px",
                        }}
                      >
                        <img
                          src="/static/images/drugOrder/approve_check.png"
                          style={{ width: "10px 0px", marginRight: "7px" }}
                        ></img>
                        <label style={{ color: "green" }}>APPROVE</label>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          color: "gray",
                        }}
                      >
                        ตรวจสอบโดย
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "10px 0px",
                        }}
                      >
                        {item?.approved_by_name}
                      </div>
                    </div>
                  )
                )}
              </div>
            )}
          </div>
        ),
        delete: canDelete && (
          <DeleteColumn
            value={true}
            id={item.id}
            titleName={`ต้องการลบ รายการสั่งยา ${ESTIMATE_MAP[orderType]} นี้ใช่หรือไม่`}
            size="mini"
            titleColor="orange"
            onConfirm={() =>
              props.onEvent({
                message: "DeleteDrugOrderItem",
                params: {
                  orderType: orderTypeTab,
                  id: item.id,
                  item,
                  orderDate: filterCreateDateRef.current,
                },
              })
            }
            languageUX={props.languageUX}
          />
        ),
        edit: checkAllowEditOrder(item) && !hideActionMenu && !isLocked && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              color="blue"
              icon="pencil"
              onClick={(e) => handleSelectRow(e, item)}
              size="mini"
            ></Button>
          </div>
        ),
        status: (
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto" }}>
            <div>{getDrugStatusName(item.status_name)}</div>
            <ButtonLockDrugOrder
              onEvent={props.onEvent}
              setProp={props.setProp}
              status={item.locker_general_status}
              orderId={item.id}
              errorMessage={props.errorMessage}
              buttonLoadCheck={props.buttonLoadCheck}
              readOnly={props.selectedDivision?.type_label !== "ห้องยา"}
              style={{ marginRight: "0.25rem" }}
              onSuccess={handleRefreshDrugList}
            />
          </div>
        ),
      };
    });
  }, [
    props.drugOrderList,
    orderType,
    handleSelectRow,
    props.buttonLoadCheck,
    props.errorMessage,
    handleRefreshDrugList,
  ]);

  const remedList = useMemo(() => {
    return (props.modReMedication?.remedData || [])
      .filter((item: any) => item.show)
      .map((item: any) => {
        return {
          ...item,
          selected: (
            <Checkbox
              checked={
                (item.order && props.modReMedication?.selectedDrugs?.includes(item.drugId)) || // for drug type
                (!item.order && props.modReMedication?.selectedOrders?.includes(item.orderId)) // for order type
              }
              onChange={(e, { checked }) => {
                if (item?.order) {
                  // drug type
                  props.onEvent({
                    message: "HandleReMedication",
                    params: {
                      action: "select_drug",
                      card: CARD_DRUG_ORDER_ID,
                      drugId: item.drugId,
                    },
                  });
                } else {
                  // order type
                  props.onEvent({
                    message: "HandleReMedication",
                    params: {
                      action: "select_order",
                      card: CARD_DRUG_ORDER_ID,
                      orderId: item.orderId,
                    },
                  });
                }
              }}
            />
          ),
          name: item.name ? (
            item.name
          ) : (
            <div
              style={{ width: "100%", height: "100%" }}
              onClick={() => {
                if (item.orderId) {
                  props.onEvent({
                    message: "HandleReMedication",
                    params: {
                      action: "show_drug",
                      orderId: item.orderId,
                    },
                  });
                }
              }}
            >
              {item.doctor_name +
                " " +
                moment(new Date(item.created)).format("DD/MM/YYYY [[]HH:mm[]]")}
            </div>
          ),
          unit: item.unit
            ? getLabelWithId(props.drugOrderItemMasterData?.masterUnits || [], item.unit, "text")
            : "",
        };
      });
  }, [props.modReMedication]);

  const hideDrugForm = useMemo(() => {
    const checkRequire = (requireKey: string) => {
      const required: boolean = props.DrugSelectSequence?.[`require_${requireKey}`];

      return !required && typeof required !== "undefined";
    };

    return {
      dose: checkRequire("unit"),
      unit: checkRequire("unit"),
      route: checkRequire("route"),
      site: checkRequire("site"),
      frequency: checkRequire("frequency"),
      method: checkRequire("method"),
      duration: ["STAT_OPD", "STAT_IPD", "ONE_DOSE_IPD", "ONE_DOSE_OPD"].includes(orderType),
    };
  }, [props.DrugSelectSequence, props.selectedDrug, orderType]);

  // const hideDrugDescription = useMemo(() => {
  //   // return !checkFrequencyUD(
  //   //   props.DrugSelectSequence?.drugFrequencies,
  //   //   props.DrugSelectSequence?.selectedDrugFrequencyId
  //   // );
  //   return false;
  // }, [
  //   props.DrugSelectSequence?.drugFrequencies,
  //   props.DrugSelectSequence?.selectedDrugFrequencyId,
  // ]);

  /* ------------------------------------------------------ */

  /*                       // HANDLER                       */

  /* ------------------------------------------------------ */

  // TABLE
  const handleDrugItemsTrProps = (state: any, rowInfo: any, column: any, instance: any) => {
    return {
      style: {
        lineHeight: 1.75,
        // display: props.isCardRejectOrder
        //   ? (rowInfo?.original?.rejected && rowInfo?.original?.id) ||
        //     !rowInfo?.original?.id
        //     ? ""
        //     : "none"
        //   : "",
      },
      onClick: () => {
        props.onEvent({
          message: "GetDrugItemDetail",
          params: {
            selectedDrugId: rowInfo?.original?.product,
            selectedDrugIndex: rowInfo?.index,
            card: CARD_DRUG_ORDER_ID,
            orderType,
          },
        });
      },
    };
  };

  const handleMouseEnter = (
    event: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    isDrugAdmixture: boolean,
    isSolvent: boolean
  ) => {
    const row = event.currentTarget;
    row.classList.add("linked-row");

    const nextRow = row.nextElementSibling as HTMLTableRowElement | null;
    const prevRow = row.previousElementSibling as HTMLTableRowElement | null;

    if (isDrugAdmixture && nextRow) {
      nextRow.classList.add("linked-row");
    } else if (isSolvent && prevRow) {
      prevRow.classList.add("linked-row");
    }
  };

  const handleMouseLeave = (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    const row = event.currentTarget;
    row.classList.remove("linked-row");

    const nextRow = row.nextElementSibling as HTMLTableRowElement | null;
    const prevRow = row.previousElementSibling as HTMLTableRowElement | null;

    if (nextRow) {
      nextRow.classList.remove("linked-row");
    }

    if (prevRow) {
      prevRow.classList.remove("linked-row");
    }
  };

  const handleDrugItemsTrGroupProps = (state: any, rowInfo: any) => {
    const original = rowInfo?.original || {};

    return {
      // className: original.drug_admixture_order_key || original.is_solvent ? "linked-row" : "",
      style: {
        // borderBottom: original.drug_admixture_order_key ? 0 : "",
        lineHeight: 1.5,
        borderBottom: 0,
      },
      onMouseEnter: (event: any) =>
        handleMouseEnter(event, original.isDrugAdmixture, original.is_solvent),
      onMouseLeave: handleMouseLeave,
    };
  };

  const getRowLastCell = (index: number) => {
    const rows = document.querySelectorAll(".table-drug-order-request .rt-tr-group");
    const currentRow = rows[index];

    if (!currentRow) {
      return null;
    }

    const rowCells = currentRow.querySelectorAll(".rt-td");
    const rowLastCell = rowCells[rowCells.length - 1];

    if (!rowLastCell) {
      return null;
    }

    return Array.from(rowLastCell.childNodes).find(
      (node) => node instanceof HTMLElement
    ) as HTMLElement;
  };

  const adjustRemoveCellPosition = (rowInfo: any) => {
    const rows = document.querySelectorAll(".table-drug-order-request .rt-tr-group");
    const currentRowIndex = rowInfo.index;
    const currentRow = rows[currentRowIndex];
    const prevRow = rows[currentRowIndex - 1];

    if (!(currentRow && prevRow)) {
      return;
    }

    const currentRowHeight = currentRow.getBoundingClientRect().height;
    const prevRowHeight = prevRow.getBoundingClientRect().height;
    const topPosition = (prevRowHeight + currentRowHeight) / 2;

    const lastCell = getRowLastCell(currentRowIndex - 1);

    if (lastCell) {
      lastCell.style.top = `${topPosition - 70.5}px`;
      lastCell.style.zIndex = "1";
    }
  };

  const handleDrugItemsTdProps = (state: any, rowInfo: any, column: any, instance: any) => {
    const original = rowInfo?.original || {};
    const borderBottom =
      column.id === "_remove" && original.isDrugAdmixture ? "" : "solid 1px rgba(0,0,0,0.05)";

    if (rowInfo) {
      const lastCell = getRowLastCell(rowInfo.index);

      if (!original.isNextItemSolvent && lastCell) {
        lastCell.style.top = "0";
      }
    }

    if (original.is_solvent) {
      if (column.id === "route") {
        return {
          colSpan: 4,
          style: {
            borderBottom,
            minWidth: "450px", // Adjust this value as needed
          },
        };
      } else if (["frequency", "site", "prn"].includes(column.id)) {
        return { style: { display: "none", borderBottom } };
      } else if (column.id === "_remove") {
        setTimeout(() => {
          adjustRemoveCellPosition(rowInfo);
        }, 0);
      }
    }

    return {
      style: {
        borderBottom,
        overflow: "unset",
        position: "relative",
        ...(original.priority === PRIORITY_TYPE.STAT &&
          orderTypeTab === DRUG_ORDER_TYPE.DAILY && { color: "red", fontWeight: "bold" }),
      },
    };
  };

  const handleListRowProps = (state: any, rowInfo: any, column: any, instance: any) => {
    const original = rowInfo?.original || {};

    return {
      style: {
        backgroundColor:
          props.drugOrder?.isSelected && original.id === props.drugOrder?.id ? "#cccccc" : "white",
        ...(orderTypeTab === DRUG_ORDER_TYPE.DAILY &&
          original.orderType?.includes("STAT") && { color: "red", fontWeight: "bold" }),
      },
      onClick: (e: any) => {
        if (checkAllowEditOrder(original)) {
          handleSelectRow(e, original);
        }
      },
    };
  };

  // const handleDrugRowProps = (state: any, rowInfo: any, column: any, instance: any) => {
  //   return {
  //     onClick: (e: any) => {
  //       setErrorMessage(null);

  //       props.onEvent({
  //         message: "RunSequence",
  //         params: {
  //           sequence: "DrugSelect",
  //           selectedDrug: props?.drugSearchResult[rowInfo?.index],
  //           card: CARD_DRUG_ORDER_ID,
  //           patient: props.selectedAppointment?.patient,
  //           orderType,
  //         },
  //       });
  //     },
  //   };
  // };

  // const handleOrderTrProps = (state: any, rowInfo: any, column: any, instance: any) => {
  //   return {
  //     style: {
  //       backgroundColor:
  //         rowInfo?.original?.id &&
  //         rowInfo?.original?.id === props.DrugOrderTemplateSequence?.selectedOrderId
  //           ? "#cccccc"
  //           : "white",
  //     },
  //   };
  // };

  const changeOrderType = (item: string) => {
    props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
    setOrderTypeTab(item);
  };

  // const handleConfirmDrugGroupDuplicateWithReason = (reason: any) => {
  //   // const error = props.errorMessage?.[CARD_DUPLICATE_REASON];

  //   props.onEvent({
  //     message: "AddToOrder",
  //     params: {
  //       orderType: orderType,
  //       onFailed: setErrorMessage,
  //       isCheckDrugGroup: true,
  //       noteGroupDuplicated: reason?.duplicated_note,
  //       card: CARD_DRUG_ORDER,
  //     },
  //   });
  // };

  const handleConfirmDrugGroupDuplicateWithReason = ({ duplicatedNotes }: any) => {
    console.log("onApprove duplicatedNotes: ", duplicatedNotes);
    props.onEvent({
      message: "AddToOrder",
      params: {
        orderType: orderType,
        isCheckDrugGroup: true,
        noteGroupDuplicated: duplicatedNotes,
        drugItems: props.modDuplicateDrug.drugItems,
        duplicateList: props.modDuplicateDrug.duplicateList,
        card: CARD_DRUG_ORDER,
      },
    });
  };

  const handleConfirmDrugDuplicateWithReason = (reason: any) => {
    // const error = props.errorMessage?.[CARD_DUPLICATE_REASON];

    props.onEvent({
      message: "AddToOrder",
      params: {
        orderType: orderType,
        onFailed: setErrorMessage,
        isCheckDrugGroup: true,
        noteGroupDuplicated: reason?.duplicated_note,
        card: CARD_DRUG_ORDER,
      },
    });
  };

  const handleAddToOrder = () => {
    console.log("handleAddToOrder: Issue 59228 ");

    // TODO: Issue 59228 ( Stat, One Dose, One Day, Home med )

    const textAlert: any[] = [];
    const drug = props.DrugSelectSequence || {};

    const checkEmpty = (value: any, key: keyof typeof hideDrugForm) => {
      return !value && !hideDrugForm[key];
    };

    if (!props.drugSearchText) {
      textAlert.push("กรุณาระบุค่าใน drug");
    }
    if (checkEmpty(props.drugDose, "dose")) {
      textAlert.push("กรุณาระบุค่าใน dose");
      textAlert.push("กรุณาระบุค่า dose ให้มีจำนวนมากกว่า 0");
    }
    if (props.drugDose === "0" && !hideDrugForm.dose) {
      textAlert.push("กรุณาระบุค่า dose ให้มีจำนวนมากกว่า 0");
    }
    if (checkEmpty(drug.selectedDrugUnitId, "unit")) {
      textAlert.push("กรุณาระบุค่าใน unit");
    }
    if (checkEmpty(drug.selectedDrugRouteId, "route")) {
      textAlert.push("กรุณาระบุค่าใน route");
    }
    if (checkEmpty(drug.selectedDrugSiteId, "site")) {
      textAlert.push("กรุณาระบุค่าใน site");
    }
    if (checkEmpty(drug.selectedDrugFrequencyId, "frequency")) {
      textAlert.push("กรุณาระบุค่าใน frequency");
    }
    if (!props.drugQty) {
      textAlert.push("กรุณาระบุค่าใน quantity");
      textAlert.push("กรุณาระบุค่า quantity ให้มีจำนวนมากกว่า 0");
    }
    if (props.drugQty === "0") {
      textAlert.push("กรุณาระบุค่า quantity ให้มีจำนวนมากกว่า 0");
    }

    setErrorMessage(textAlert);
    if (textAlert.length === 0) {
      props.onEvent({
        message: "AddToOrder",
        params: {
          orderType: orderType,
          onFailed: setErrorMessage,
          isCheckDrugGroup: true,
          card: CARD_DRUG_ORDER,
        },
      });
      setErrorMessage(null);
    }
    setDataChanged(true);
    setOpenCalculator(false);
  };

  const handleClearDrugOrderForm = async () => {
    setErrorMessage(null);

    const seq = props.DrugSelectSequence || {};

    await props.setProp("DrugSelectSequence.priority", seq.prevPriority || seq.priority);

    props.onEvent({ message: "ClearDrugOrderForm", params: {} });
    setOpenCalculator(false);
  };

  const handleConfirmOrder = async (params: any = {}) => {
    const isConfirmed = props.openModPharmacistNote?.confirmed;
    const isOpenConfirm = !(isConfirmed || modPharmaConfirm?.note);

    if (!props.currentDoctor?.id && isOpenConfirm) {
      setModPharmaConfirm({
        open: true,
        note: "",
        duplicated_note: params.duplicated_note,
        confirm_duplicated_drugs: params.confirm_duplicated_drugs,
      });
      return;
    }

    const orderDate = filterCreateDateRef.current;

    if (props.isCardRejectOrder) {
      await props.onEvent({
        message: "ConfirmDrugOrder",
        params: {
          orderType: orderTypeTab,
          card: CARD_DRUG_ORDER,
          cardKey: CARD_DRUG_ORDER,
          // action: "SAVE",
          note: modPharmaConfirm?.note,
          data_changed: dataChanged,
          orderDate,
          action: "CONFIRM",
          ...params,
        },
      });
    } else {
      if (props.onDuplicateApprove) {
        const duplicatedNote = modPharmaConfirm.duplicated_note || params.duplicated_note;

        await props.onDuplicateApprove?.(
          isConfirmed
            ? {
                note: props.openModPharmacistNote?.note,
                duplicated_note: duplicatedNote,
                confirm_duplicated_drugs: true,
              }
            : {
                note: modPharmaConfirm?.note,
                duplicated_note: duplicatedNote,
                confirm_duplicated_drugs: modPharmaConfirm.confirm_duplicated_drugs,
              }
        );

        return;
      }

      await props.onEvent({
        message: "ConfirmDrugOrder",
        params: {
          orderType: orderTypeTab,
          card: CARD_DUPLICATE_REASON,
          cardKey: CARD_DRUG_ORDER,
          // action: "SAVE",
          note: modPharmaConfirm?.note,
          data_changed: dataChanged,
          orderDate,
          action: "CONFIRM",
          ...params,
          onSuccess: () => {
            if (!props.hiddenDrugList) {
              setStatusRequested(false);
            }

            setModPharmaConfirm({ open: false, note: "" });
          },
        },
      });
    }
    setModPharmaConfirm({ ...modPharmaConfirm, open: false });
  };

  // const handleChangeDrugDose = (e: any) => {
  //   const value = e.target.value;
  //   props.setProp("drugDose", value === "" ? "" : +value < 0 ? "0" : value);
  // };

  // const handleBlurDrugDose = (e: any) => {
  //   const value = e.target.value;
  //   props.onEvent({
  //     message: "HandleChangeDrugOrderDetail",
  //     params: {
  //       key: "drugDose",
  //       value: value === "" ? "" : +value < 0 ? "0" : value,
  //       orderType,
  //       card: CARD_DRUG_ORDER,
  //     },
  //   });
  // };

  // Mod Solvent Selection
  const handleOpenModSolventSelection = async () => {
    await props.onEvent({
      message: "SetModSolventSelectionConfig",
      params: { activeButtonSolvent: true, editable: true, editableQuantity: true },
    });

    const { params } = prepareModSolventSelection({
      drug: props.DrugSelectSequence,
      drugPermission: props.drugPermission,
      frequency: props.masterData?.frequency,
      orderType: props.orderType,
      solvent: props.modSolventSelectionConfig,
    });

    props.onEvent({
      message: "initModSolventSelection",
      params,
    });
  };

  // const handleCloseModSolventSelection = () => {
  //   props.onEvent({
  //     message: "SetModSolventSelectionConfig",
  //     params: { openModal: false },
  //   });
  // };
  const getDrugSolventOrderItem = (drugDetail: Record<string, any>) => {
    const data = props.modSolventSelectionConfig;

    const product = props.searchedItemListWithKey?.Drug_EMO?.find(
      (item: any) => item.id === data?.solvent
    );

    const solvent = {
      iv_rate: data?.mixture_iv_rate || data?.iv_rate,
      // dose: drugSelectSeq?.dose,
      quantity: data?.quantity,
      unit: data?.unit,
      product: data?.solvent,
      product_name: product?.full_name,
      title: `${product?.full_name} ${data.price_unit?.toFixed(2) || ""} ฿`,
      // mixture_iv_rate: data.mixture_iv_rate || 0,
      // mixture_iv_rate_unit: data.mixture_iv_rate_unit,
      // drug_drip_in: data.drug_drip_in || 0,
      // drug_drip_in_unit: data.drug_drip_in_unit,
      solvent_volume: data.volume,
      priority: drugDetail.priority,
    };

    const drug = {
      description: props.drugDescription || "",
      dose: props.drugDose,
      duration: props.drugDuration || 0,
      frequency: drugDetail.selectedDrugFrequencyId,
      prn: props.drugPrn || "",
      quantity: props.drugQty,
      route: drugDetail.selectedDrugRouteId,
      site: drugDetail.selectedDrugSiteId,
      unit: drugDetail.selectedDrugUnitId,
      mixture_iv_rate: data.mixture_iv_rate || 0,
      mixture_iv_rate_unit: data.mixture_iv_rate_unit,
      drug_drip_in: data.drug_drip_in || 0,
      drug_drip_in_unit: data.drug_drip_in_unit,
      priority: drugDetail.priority,
    };

    return { solvent, drug };
  };

  const handleAddSolventToOrder = async () => {
    const data = props.modSolventSelectionConfig;

    const { solvent: solventDetail } = setDrugSolventDetail({}, data);
    const { solvent, drug } = getDrugSolventOrderItem(props.DrugSelectSequence);
    const updatedSolvent = {
      ...solventDetail,
      ...solvent,
    };

    await props.onEvent({
      message: "SetDrugOrderItemsData",
      params: {
        index: data.admixtureIndex,
        isAddSolvent: true,
        items: updatedSolvent,
        orderType: orderTypeTab,
        onSuccess: () => {
          props.onEvent({
            message: "AddToOrder",
            params: {
              card: CARD_DRUG_ORDER_ID,
              drugIndex: [props.selectedDrug?.index, data.admixtureIndex],
              editItem: {
                ...drug,
                drug_admixture_order_key: updatedSolvent.drug_admixture_order_key,
              },
              orderType,
            },
          });

          handleClearDrugOrderForm();
        },
      },
    });

    // const drugSelectSeq: any = props.DrugSelectSequence;
    // const modSolventConfig: any = props.modSolventSelectionConfig;
    // const drug_admixture_order_key =
    //   props.modSolventSelectionConfig?.admixtureSolute?.drug_admixture_order_key || uuidv4();

    // if (!modSolventConfig?.solvent) return;

    // await props.onEvent({
    //   message: "SetDrugOrderItemsData",
    //   params: {
    //     index: props.modSolventSelectionConfig.admixtureIndex,
    //     items: {
    //       iv_rate: drugSelectSeq?.mixture_iv_rate,
    //       dose: drugSelectSeq?.dose,
    //       unit: drugSelectSeq?.unit,
    //       drug_admixture_order_key: drug_admixture_order_key,
    //     },
    //   },
    // });

    // if (props.drugPermission?.config_TPD_ENABLE_IV_COMPATIBLE) {
    //   props.onEvent({
    //     message: "AddToOrder",
    //     params: {
    //       drugItems: [
    //         {
    //           product: modSolventConfig?.solvent,
    //           product_name: modSolventConfig?.selectedSolvent?.full_name,
    //           stock_unit_name: modSolventConfig?.selectedSolvent?.stock_unit_name,
    //           drug_list: modSolventConfig?.selectedSolvent?.drug_list,
    //           dose: "0",
    //           quantity: drugSelectSeq?.solvent_quantity,
    //           volume: drugSelectSeq?.mixture_solvent_volume,
    //           solvent_volume: drugSelectSeq?.mixture_solvent_volume,
    //           solute_concentration_rate: drugSelectSeq?.mixture_concentration_solute,
    //           solvent_concentration_rate: drugSelectSeq?.mixture_concentration_solvent,
    //           concentration_unit: drugSelectSeq?.drug_concentration_unit,
    //           mixture_iv_rate: drugSelectSeq?.mixture_iv_rate,
    //           mixture_iv_rate_unit: drugSelectSeq?.mixture_iv_rate_unit,
    //           drug_drip_in: drugSelectSeq?.drug_drip_in,
    //           drug_drip_in_unit: drugSelectSeq?.drug_drip_in_unit,
    //           is_solvent: true,
    //           drug_admixture_order_key: drug_admixture_order_key,
    //         },
    //       ],
    //       orderType: orderType,
    //       card: CARD_DRUG_ORDER_ID,
    //     },
    //   });
    // } else {
    //   props.onEvent({
    //     message: "AddToOrder",
    //     params: {
    //       drugItems: [
    //         {
    //           product: modSolventConfig?.solvent,
    //           product_name: modSolventConfig?.selectedSolvent?.full_name,
    //           stock_unit_name: modSolventConfig?.selectedSolvent?.stock_unit_name,
    //           drug_list: modSolventConfig?.selectedSolvent?.drug_list,
    //           dose: drugSelectSeq?.solvent_quantity,
    //           quantity: drugSelectSeq?.solvent_quantity,
    //           is_solvent: true,
    //           drug_admixture_order_key: drug_admixture_order_key,
    //         },
    //       ],
    //       orderType: orderType,
    //       card: CARD_DRUG_ORDER_ID,
    //     },
    //   });
    // }
  };

  const handleClickDrugHistory = () => {
    setOpenModDrugHistory(true);
  };

  const handleCloseModDrugHistory = () => {
    setOpenModDrugHistory(false);
  };

  const handleDrugHistoryAddToOrder = async (items: any[], checked: number[]) => {
    const data = props.drugOrderItemMasterData || {};

    const getValue = (options: any, value: any) => {
      return value
        ? (options || []).find((item: any) => item.text.includes(`(${value})`))?.value || ""
        : value;
    };

    await props.setProp("modReMedication", {
      remedData: items.map((item) => ({
        ...item,
        drugId: item.id,
        product_name: item.name,
        frequency: getValue(data.masterFrequencies, item.code_frequency),
        method: getValue(data.masterMethods, item.code_method),
        route: getValue(data.masterRoutes, item.code_route),
        site: getValue(data.masterSites, item.code_site),
        unit: getValue(data.masterUnits, item.code_unit),
      })),
      selectedDrugs: checked,
    });

    props.onEvent({
      message: "HandleReMedication",
      params: {
        action: "add_to_order",
        card: CARD_DRUG_ORDER_ID,
        orderType,
      },
    });

    handleCloseModDrugHistory();
  };

  const handleChangeDate = (date: string) => {
    props.setProp("DrugSelectSequence.selectedDate", date);
  };

  const handleCloseModDesc = () => {
    setModDrugDesc({});
  };

  const handleConfirmDesc = (description: string) => {
    props.onEvent({
      message: "AddToOrder",
      params: {
        editItem: { description },
        drugIndex: modDrugDesc.index,
        orderType: orderType,
        card: CARD_DRUG_ORDER_ID,
      },
    });

    handleCloseModDesc();
  };

  const handleAddNewOrder = () => {
    handleClearDrugOrderForm();

    setIsOutsideDrug(false);

    props.onEvent({
      message: "SetDrugOrder",
      params: { orderType: orderTypeTab, card: CARD_DRUG_ORDER_ID },
    });

    setStatusRequested(true);
  };

  const handleCloseDrugPackageAlert = () => {
    props.setProp("drugPackageAlertList", []);
  };

  const handleCloseDrugOrderMessage = () => {
    if (typeof props.errorMessage?.[CARD_DRUG_ORDER]?.showMessage === "undefined") {
      props.setProp(`errorMessage.${CARD_DRUG_ORDER}`, null);
    } else {
      props.setProp(`errorMessage.${CARD_DRUG_ORDER_ID}.showMessage`, false);
    }
  };

  const handlePackageAddToOrder = (selected: any[]) => {
    props.onEvent({
      message: "DrugPackageAddToOrder",
      params: {
        items: selected,
        orderType: orderType,
        card: CARD_DRUG_ORDER,
      },
    });
  };

  const handleCloseModDispense = () => {
    setOpenModDispense(false);
  };

  const handleSaveDrugDispense = async (data: any) => {
    props.setProp("drugDose", data.dose);
    props.setProp("drugQty", data.quantity);

    await props.setProp("DrugSelectSequence", {
      ...props.DrugSelectSequence,
      selectedDrugUnitId: data.unit,
      selectedDrugRouteId: data.route,
      selectedDrugFrequencyId: data.frequency,
      isDrugDispense: true,
    });

    props.onEvent({
      message: "AddToOrder",
      params: {
        orderType: orderType,
        onFailed: setErrorMessage,
        isCheckDrugGroup: true,
        card: CARD_DRUG_ORDER,
      },
    });

    handleCloseModDispense();
  };

  const handleChangeFilterCreateDate = (data: { date: string; type: "next" | "prev" }) => {
    const { date: inputDate, type } = data;

    let date = inputDate || filterCreateDateRef.current;

    // ตรวจสอบว่า date มีค่าและมีรูปแบบที่ถูกต้อง
    if (!(type || /\b\d{2}\/\d{2}\/\d{4}\b/.test(inputDate))) {
      return;
    }

    // ใช้ beToAd แปลงวันที่และเพิ่มหรือลดวันตาม type
    const formattedDate = beToAd(date)?.add(type === "next" ? 1 : -1, "days");

    if (type) {
      date = formatDate(formattedDate);
    }

    // ตรวจสอบวการแปลงวัน
    if (formattedDate) {
      handleGetDrugOrderList({ orderDate: date });

      filterCreateDateRef.current = date;
      if (isTodayBEString(date)) {
        setTodayHelper(true);
      } else {
        setTodayHelper(false);
      }
    } else {
      console.error("Failed to format the date.");
    }
  };

  const handleCloseModDrugTransport = () => {
    props.onEvent({
      message: "RunSequence",
      params: { sequence: "DrugSelect", feedback: "cancel" },
    });
  };

  const handleApproveDrugTransport = () => {
    props.onEvent({
      message: "RunSequence",
      params: { sequence: "DrugSelect", feedback: "confirm", orderType: orderTypeTab },
    });
  };

  const handleChangeTelepharType = async (e: any, v: any) => {
    await props.setProp(
      "drugOrder.telephar_type",
      props.drugOrder?.telephar_type === v.name ? "NONE" : v.name
    );

    if (v.name === "DELIVERY") {
      props.onEvent({
        message: "RunSequence",
        params: {
          sequence: "DrugSelect",
          card: CARD_DRUG_ORDER_ID,
          orderType,
          patient: props.selectedAppointment?.patient,
          selectedDrug: props.DrugSelectSequence?.selectedDrug || {},
          checkDrugTransferOnly: true,
        },
      });
    }
  };

  const handleCloseModUnlinkMixture = () => {
    setModConfirmUnlinkMixture(null);
  };

  const handleConfirmUnlinkMixture = () => {
    if (!modConfirmUnlinkMixture) {
      return;
    }

    columnRemoveRef.current[modConfirmUnlinkMixture.product].style.top = "0";

    props.onEvent({
      message: "HandleOnRemoveDrug",
      params: {
        action: "unlink_mixture",
        removeAdmixtureKey: modConfirmUnlinkMixture.drug_admixture_order_key,
        card: CARD_DRUG_ORDER_ID,
      },
    });

    handleCloseModUnlinkMixture();
  };

  const handleApproveDuplicateDrug = async (data: any) => {
    // handleConfirmOrder({ action: "SAVE", ...data })
    if (props.drugOrder) {
      await handleConfirmOrder({
        ...data,
        confirm_duplicated_drugs: true,
        approved_by_username: props.drugOrder?.approved_by_username,
        approved_by_password: props.drugOrder?.approved_by_password,
      });
    } else {
      await handleConfirmOrder({
        action: "SAVE",
      });
    }
  };

  console.log("CardDrugOrder props: ", props);
  console.log("CardDrugOrder props.drugOrder?.id: ", props.drugOrder?.id);
  console.log("CardDrugOrder props.drugOrderEdit: ", props.drugOrderEdit);

  return (
    <div
      id="CardDrugOrder"
      style={{
        width: "100%",
        paddingBottom: props.isCardRejectOrder ? "" : "2rem",
      }}
    >
      {/* height: "100%" */}
      {!props.disabledVerbalMedOrder &&
      // props.selectedVerbalDrugOrderWorking &&
      // Object.keys(props.selectedVerbalDrugOrderWorking || {})?.length !== 0 &&
      props.isVerbalOrder &&
      props.drugOrder?.order_type &&
      props.drugOrder?.order_type !== "DIRECT" ? (
        <div style={{ fontSize: "1rem", textAlign: "center" }}>
          <Message compact info style={{ width: "20%", marginRight: "2rem", textAlign: "left" }}>
            <MessageHeader>{intl.formatMessage({ id: "รคส แพทย์" })}</MessageHeader>
            <p>
              {ORDER_TYPES[VERBAL_ORDER_MAPPED[selectedVerbalDrugOrder?.order_specific_type]] ? (
                <>
                  {ORDER_TYPES[VERBAL_ORDER_MAPPED[selectedVerbalDrugOrder?.order_specific_type]]}
                </>
              ) : null}
              {selectedVerbalDrugOrder?.drug_order_code ? (
                <> / Code: {selectedVerbalDrugOrder?.drug_order_code} </>
              ) : null}
            </p>
          </Message>

          <Message icon compact warning style={{ width: "50%", textAlign: "left" }}>
            <Icon name="pencil" size="tiny" />
            <MessageContent>
              <MessageHeader>{intl.formatMessage({ id: "รคส:" })}</MessageHeader>
              {selectedVerbalDrugOrder?.note}
            </MessageContent>
          </Message>

          <Message compact info style={{ width: "20%", marginLeft: "2rem", textAlign: "left" }}>
            <MessageHeader>{intl.formatMessage({ id: "ผู้บันทึกคำสั่ง" })}</MessageHeader>
            {selectedVerbalDrugOrder?.editor ? <p> {selectedVerbalDrugOrder?.editor}</p> : null}
          </Message>
        </div>
      ) : null}
      {!props.hiddenMenuOrderType && props.orderTypes?.length && props.orderTypes.length > 1 && (
        <div
          className="tab-drug-order-type"
          style={{
            display: "flex",
            borderBottom: "solid #cccccc 1px",
            padding: "5px",
          }}
        >
          {props.orderTypes
            .filter((item: any) => Object.keys(ORDER_TYPES).includes(item))
            .map((item: any, index: number) => (
              <div key={item}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div
                    style={{
                      position: "absolute",
                      display: props.drugOrderNotification?.[`${item}`] ? "flex" : "none",
                      backgroundColor: "red",
                      borderRadius: "50%",
                      width: "1em",
                      height: "1em",
                      justifyContent: "flex-end",
                      marginTop: "-4px",
                    }}
                  />
                </div>
                <Button
                  key={index}
                  size="tiny"
                  color={orderTypeTab === item ? "blue" : undefined}
                  onClick={() => {
                    if (orderTypeTab !== item) {
                      changeOrderType(item);
                      setStatusRequested(false);
                    }
                  }}
                >
                  {ORDER_TYPES[item]}
                </Button>
              </div>
            ))}
        </div>
      )}

      {props.title ? (
        <div style={{ fontWeight: "bolder", marginLeft: "5px" }}> {props.title} </div>
      ) : null}
      <CardDrugOrderUX
        hideCardDrugVerbalOrder={props.hideCardDrugVerbalOrder}
        helperLabel={
          todayHelper ? (
            <div style={{ marginLeft: "10px" }}>
              {" "}
              <Label size="mini">{intl.formatMessage({ id: "รายการใบยาในวันนี้" })}</Label>{" "}
            </div>
          ) : null
        }
        orderStatus={orderName === "" ? "รายการยาสั่งใหม่" : "แก้ไขรายการยา"}
        styleDrugOrderTable={{
          ...(statusRequested && { height: openCalCulator ? "380px" : "300px" }),
          maxHeight: "80vh",
        }}
        noDataComponent={() =>
          props.drugOrderListLoading ? null : (
            <div className="rt-noData">{intl.formatMessage({ id: "ไม่พบใบยาประเภทนี้" })}</div>
          )
        }
        tableElement={
          <Table
            className="--rt-tbody-overflow-y-hidden table-drug-order-request"
            data={renderDrugOrderItems}
            getTrProps={handleDrugItemsTrProps}
            getTrGroupProps={handleDrugItemsTrGroupProps}
            getTdProps={handleDrugItemsTdProps}
            headers="Drug,Route,Dose,Unit,Site,Frequency,PRN,QTY,Duration,Price/Unit,Total Price,เบิกได้,เบิกไม่ได้,"
            id="tb-medicationList"
            keys="title_status,route,dose,unit,site,frequency,prn,quantity,duration,price_unit,price_total,price_claimable,price_non_claimable,_remove"
            minRows="6"
            showPagination={false}
            style={{ height: "325px" }}
            widths="^130,180,^60,90,90,90,90,^60,^70,^75,^75,^75,^75,^50"
          />
        }
        priceClaimable={formatComma(price.priceClaimable)}
        priceNonClaimable={formatComma(price.priceNonClaimable)}
        priceTotal={formatComma(price.priceTotal)}
        orderName={
          orderName !== "" && (
            <div style={{ marginRight: "20px " }}>
              <Label color="blue">{getDrugTypeName(orderName)}</Label>
            </div>
          )
        }
        loader={props.drugOrderListLoading ? <Loader active> </Loader> : null}
        disabledAddDrugOrderBtn={props.drugOrderListLoading}
        approveStatus={
          props.drugOrder?.need_approve === true && props.drugOrder?.student_name ? (
            <div
              style={{
                color: "gray",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={"/static/images/drugOrder/need_approve.png"}
                style={{ marginRight: "5px" }}
              />
              <label>NEED APPROVE</label>
            </div>
          ) : (
            props.isStudentUser &&
            props.drugOrder?.need_approve === false &&
            props.drugOrder?.approved_by_name && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={"/static/images/drugOrder/approve_check.png"}
                  style={{ marginRight: "5px" }}
                />
                <label style={{ color: "green", marginRight: "10px" }}>APPROVE</label>
                <div style={{ display: "flex", color: "black" }}>
                  <label>
                    {"[ "}
                    <span style={{ color: "#898383" }}>{intl.formatMessage({ id: "โดย" })} </span>
                    {props.drugOrder?.approved_by_name} {" ]"}
                  </label>
                </div>
              </div>
            )
          )
        }
        showRecon={orderType === "HOME_IPD"}
        isStudentUser={props.isStudentUser}
        onClickRecontinueMed={() => {
          props.onEvent({
            message: "HandleModRecontinueMedication",
            params: { action: "OPEN", card: CARD_DRUG_ORDER },
          });
        }}
        onPrintDrugOrder={() => {
          props.onEvent({
            message: "PrintDrugOrderFromDoctor",
            params: { card: CARD_DRUG_ORDER },
          });
        }}
        onPrintNarcotic={() => {
          props.onEvent({
            message: "HandlePrintNarcoticForm",
            params: {
              order_id: props.drugOrder?.id,
              loading: "PRINT_NARCOTIC_FORM",
              card: CARD_DRUG_ORDER,
            },
          });
        }}
        onPrintPsychotropic={() => {
          props.onEvent({
            message: "HandlePrintPsychotropicForm",
            params: {
              order_id: props.drugOrder?.id,
              loading: "PRINT_PSYCHOTROPIC_FORM",
              card: CARD_DRUG_ORDER,
            },
          });
        }}
        disabledPrintDrugOrderBtn={!props.drugOrder?.id}
        hiddenDrugList={props.hiddenDrugList}
        isShowNarcoticPrint={props.drugOrder?.isShowNarcotic}
        hasDrugTransportNotAllowed={props.drugOrder?.drugTransportNotAllowedIds?.length}
        isShowPsychotropicPrint={props.drugOrder?.isShowPsychotropic}
        loadingStatus={props.loadingStatus}
        // Element
        ErrorMessage={<ErrorMessage error={errorMessage} />}
        errorMessage={errorMessage}
        orderType={orderType}
        drugOrderList={drugOrderList}
        statusRequest={statusRequested}
        hideDrugForm={hideDrugForm}
        drugFormFlexStyle={Object.values(hideDrugForm).some((hide) => hide)}
        listRowProps={handleListRowProps}
        addNewOrder={handleAddNewOrder}
        openCalCulator={openCalCulator}
        filterCreateDate={filterCreateDateRef.current}
        onChangeFilterCreateDate={handleChangeFilterCreateDate}
        // pediatricUI={
        //   openCalCulator === true ? (
        //     <ModPediatricDose
        //       open={openCalCulator}
        //       onEvent={props.onEvent}
        //       setProp={props.setProp}
        //       drugDetail={props.selectedDrug?.original}
        //       pediatricData={props.pediatricData}
        //       // callback
        //       onClose={() => setOpenCalculator(false)}
        //     />
        //   ) : (
        //     <></>
        //   )
        // }
        // pediatricWarning={
        //   <div
        //     style={{
        //       display: props.pediatricData?.selectedItem?.error ? "flex" : "none",
        //       padding: "10px",
        //       background: "#ffe8e6",
        //       color: "red",
        //       width: "fit-content",
        //     }}
        //   >
        //     {props.pediatricData?.selectedItem?.error?.map((item: any) => {
        //       return (
        //         <div style={{ paddingRight: "10px" }} dangerouslySetInnerHTML={{ __html: item }} />
        //       );
        //     })}
        //   </div>
        // }
        doctorElement={
          <SearchBox
            onEvent={props.onEvent}
            setProp={props.setProp}
            searchedItemList={props.searchedItemList}
            selectedItem={props.drugOrder?.selectedOrderBy}
            setSelectedItem={(item: any) => {
              let result = { ...props.drugOrder };
              result.selectedOrderBy = item;
              result.order_by = item?.id;
              props.setProp("drugOrder", result);
            }}
            type="Doctor"
            toDisplay={(item: any) => `${item.first_name} ${item.last_name} [${item.code}]`}
            style={{ width: "100%" }}
            fluid={true}
          />
        }
        buttonSaveOrder={
          <ButtonLoadCheck
            // function
            id="btn-confirmMedOrder"
            setProp={props.setProp}
            onClick={() =>
              handleConfirmOrder({
                action: "SAVE",
                isCardRejectOrder: props.isCardRejectOrder,
              })
            }
            // data
            paramKey={`${CARD_DRUG_ORDER}_SAVE`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_DRUG_ORDER}_SAVE`]}
            // config
            disabled={statusRequested ? (orderName && !dataChanged ? true : false) : true}
            color={"blue"}
            name="SAVE"
            // size="medium"
            title="SAVE ORDER"
            style={{ width: "100%" }}
          />
        }
        buttonConfirmOrder={
          !props.disabledConfirmedOrderBtn && (
            <ButtonLoadCheck
              // function
              id="btn-confirmMedOrder"
              setProp={props.setProp}
              onClick={handleOpenModAuthen}
              // data
              paramKey={`${CARD_DRUG_ORDER}_CONFIRM`}
              buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_DRUG_ORDER}_CONFIRM`]}
              // config
              disabled={
                statusRequested
                  ? props.isStudentUser &&
                    orderName &&
                    !dataChanged &&
                    props.drugOrder?.need_approve === false
                    ? true
                    : false
                  : true
              }
              color={"green"}
              name="SAVE"
              // size="medium"
              title="CONFIRM ORDER"
              style={{ width: "100%" }}
            />
          )
        }
        buttonTaperSchedule={
          <Popup
            content={
              <TaperPopup
                startDate={props.DrugSelectSequence?.selectedDate}
                duration={props.drugDuration}
                onChangeDate={handleChangeDate}
              />
            }
            on="click"
            position="bottom right"
            pinned
            trigger={
              <Button
                size="small"
                color="purple"
                style={{
                  padding: "0.6em 0.75em 0.6rem 0.5rem",
                  marginLeft: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  background: "#9a4082",
                  width: "9.75rem",
                }}
              >
                <img
                  src={"/static/images/taper-schedule.png"}
                  style={{ width: "1.5rem" }}
                  alt="taper-schedule.icon"
                />
                <label style={{ marginLeft: "10px" }}>Taper Schedule</label>
              </Button>
            }
          />
        }
        // DrugSearchBox={
        //   <DrugSearchBox
        //     onEvent={props.onEvent}
        //     setProp={props.setProp}
        //     // data
        //     drugSearchText={props.drugSearchText}
        //     selectedDrug={props.selectedDrug}
        //     drugSearchResult={props.drugSearchResult}
        //     drugSearchLoading={props.drugSearchLoading}
        //     // CommonInterface
        //     errorMessage={errorMessage}
        //     // config
        //     disabled={!statusRequested}
        //     // callback
        //     getTrProps={handleDrugRowProps}
        //   />
        // }
        // permission
        drugPermission={props.drugPermission}
        roleTypes={props.django?.user?.role_types}
        // Drug search
        selectedDrug={props.selectedDrug}
        // Set drug order item detail
        openFactSheet={() => setOpenModFactSheet(true)}
        minRows={openCalCulator ? "8" : "4"}
        // calculatorIcon={
        //   !config.HIDE_DOSE_CALCULATOR && (
        //     <div
        //       fluid={true}
        //       onClick={() => {
        //         if (enableCalculatorButton) {
        //           setOpenCalculator(!openCalCulator);
        //         }
        //       }}
        //       style={{ whiteSpace: "nowrap" }}
        //     >
        //       <svg
        //         width="49"
        //         height="44"
        //         viewBox="0 0 49 44"
        //         fill="none"
        //         xmlns="http://www.w3.org/2000/svg"
        //       >
        //         <path
        //           d="M7.94727 38.6416H9.40723C9.37793 39.1201 9.24609 39.5449 9.01172 39.916C8.7806 40.2871 8.45671 40.5768 8.04004 40.7852C7.62663 40.9935 7.12858 41.0977 6.5459 41.0977C6.09017 41.0977 5.68164 41.0195 5.32031 40.8633C4.95898 40.7038 4.64974 40.4759 4.39258 40.1797C4.13867 39.8835 3.94499 39.5254 3.81152 39.1055C3.67806 38.6855 3.61133 38.2152 3.61133 37.6943V37.2012C3.61133 36.6803 3.67969 36.21 3.81641 35.79C3.95638 35.3669 4.15495 35.0072 4.41211 34.7109C4.67253 34.4147 4.9834 34.1868 5.34473 34.0273C5.70605 33.8678 6.1097 33.7881 6.55566 33.7881C7.14811 33.7881 7.64779 33.8955 8.05469 34.1104C8.46484 34.3252 8.78223 34.6214 9.00684 34.999C9.2347 35.3766 9.37142 35.8063 9.41699 36.2881H7.95215C7.93587 36.0016 7.87891 35.7591 7.78125 35.5605C7.68359 35.3587 7.53548 35.2074 7.33691 35.1064C7.1416 35.0023 6.88118 34.9502 6.55566 34.9502C6.31152 34.9502 6.09831 34.9958 5.91602 35.0869C5.73372 35.1781 5.58073 35.3164 5.45703 35.502C5.33333 35.6875 5.24056 35.9219 5.17871 36.2051C5.12012 36.485 5.09082 36.8138 5.09082 37.1914V37.6943C5.09082 38.0622 5.11849 38.3861 5.17383 38.666C5.22917 38.9427 5.3138 39.1771 5.42773 39.3691C5.54492 39.5579 5.69466 39.7012 5.87695 39.7988C6.0625 39.8932 6.28548 39.9404 6.5459 39.9404C6.85189 39.9404 7.10417 39.8916 7.30273 39.7939C7.5013 39.6963 7.65267 39.5514 7.75684 39.3594C7.86426 39.1673 7.92773 38.9281 7.94727 38.6416ZM13.1328 39.8086V37.4551C13.1328 37.2858 13.1051 37.141 13.0498 37.0205C12.9945 36.8968 12.9082 36.8008 12.791 36.7324C12.6771 36.6641 12.529 36.6299 12.3467 36.6299C12.1904 36.6299 12.0553 36.6576 11.9414 36.7129C11.8275 36.765 11.7396 36.8415 11.6777 36.9424C11.6159 37.04 11.585 37.1556 11.585 37.2891H10.1787C10.1787 37.0645 10.2308 36.8512 10.335 36.6494C10.4391 36.4476 10.5905 36.2702 10.7891 36.1172C10.9876 35.9609 11.2236 35.8389 11.4971 35.751C11.7738 35.6631 12.083 35.6191 12.4248 35.6191C12.835 35.6191 13.1995 35.6875 13.5186 35.8242C13.8376 35.9609 14.0882 36.166 14.2705 36.4395C14.4561 36.7129 14.5488 37.0547 14.5488 37.4648V39.7256C14.5488 40.0153 14.5667 40.2529 14.6025 40.4385C14.6383 40.6208 14.6904 40.7803 14.7588 40.917V41H13.3379C13.2695 40.8568 13.2174 40.6777 13.1816 40.4629C13.1491 40.2448 13.1328 40.0267 13.1328 39.8086ZM13.3184 37.7822L13.3281 38.5781H12.542C12.3564 38.5781 12.1953 38.5993 12.0586 38.6416C11.9219 38.6839 11.8096 38.7441 11.7217 38.8223C11.6338 38.8971 11.5687 38.985 11.5264 39.0859C11.4873 39.1868 11.4678 39.2975 11.4678 39.418C11.4678 39.5384 11.4954 39.6475 11.5508 39.7451C11.6061 39.8395 11.6859 39.9144 11.79 39.9697C11.8942 40.0218 12.0163 40.0479 12.1562 40.0479C12.3678 40.0479 12.5518 40.0055 12.708 39.9209C12.8643 39.8363 12.9847 39.7321 13.0693 39.6084C13.1572 39.4847 13.2028 39.3675 13.2061 39.2568L13.5771 39.8525C13.5251 39.986 13.4535 40.1243 13.3623 40.2676C13.2744 40.4108 13.1621 40.5459 13.0254 40.6729C12.8887 40.7965 12.7243 40.8991 12.5322 40.9805C12.3402 41.0586 12.1123 41.0977 11.8486 41.0977C11.5133 41.0977 11.209 41.0309 10.9355 40.8975C10.6654 40.7607 10.4505 40.5736 10.291 40.3359C10.1348 40.0951 10.0566 39.8216 10.0566 39.5156C10.0566 39.2389 10.1087 38.9932 10.2129 38.7783C10.3171 38.5635 10.4701 38.3828 10.6719 38.2363C10.877 38.0866 11.1325 37.9743 11.4385 37.8994C11.7445 37.8213 12.0993 37.7822 12.5029 37.7822H13.3184ZM17.1172 33.5V41H15.7061V33.5H17.1172ZM18.3477 40.3213C18.3477 40.113 18.4193 39.9388 18.5625 39.7988C18.709 39.6589 18.9027 39.5889 19.1436 39.5889C19.3844 39.5889 19.5765 39.6589 19.7197 39.7988C19.8662 39.9388 19.9395 40.113 19.9395 40.3213C19.9395 40.5296 19.8662 40.7038 19.7197 40.8438C19.5765 40.9837 19.3844 41.0537 19.1436 41.0537C18.9027 41.0537 18.709 40.9837 18.5625 40.8438C18.4193 40.7038 18.3477 40.5296 18.3477 40.3213ZM25.9404 41H24.3926L24.4023 39.8574H25.9404C26.3245 39.8574 26.6484 39.7712 26.9121 39.5986C27.1758 39.4229 27.3743 39.1673 27.5078 38.832C27.6445 38.4967 27.7129 38.0915 27.7129 37.6162V37.2695C27.7129 36.9049 27.6738 36.5843 27.5957 36.3076C27.5208 36.0309 27.4085 35.7982 27.2588 35.6094C27.109 35.4206 26.9251 35.279 26.707 35.1846C26.4889 35.0869 26.2383 35.0381 25.9551 35.0381H24.3633V33.8906H25.9551C26.4303 33.8906 26.8649 33.972 27.2588 34.1348C27.6559 34.2943 27.9993 34.5238 28.2891 34.8232C28.5788 35.1227 28.8018 35.4808 28.958 35.8975C29.1175 36.3109 29.1973 36.7715 29.1973 37.2793V37.6162C29.1973 38.1208 29.1175 38.5814 28.958 38.998C28.8018 39.4147 28.5788 39.7728 28.2891 40.0723C28.0026 40.3685 27.6592 40.598 27.2588 40.7607C26.8617 40.9202 26.4222 41 25.9404 41ZM25.2227 33.8906V41H23.7578V33.8906H25.2227ZM29.9492 38.4121V38.3096C29.9492 37.9222 30.0046 37.5658 30.1152 37.2402C30.2259 36.9115 30.387 36.6266 30.5986 36.3857C30.8102 36.1449 31.0706 35.9577 31.3799 35.8242C31.6891 35.6875 32.0439 35.6191 32.4443 35.6191C32.8447 35.6191 33.2012 35.6875 33.5137 35.8242C33.8262 35.9577 34.0882 36.1449 34.2998 36.3857C34.5146 36.6266 34.6774 36.9115 34.7881 37.2402C34.8988 37.5658 34.9541 37.9222 34.9541 38.3096V38.4121C34.9541 38.7962 34.8988 39.1527 34.7881 39.4814C34.6774 39.807 34.5146 40.0918 34.2998 40.3359C34.0882 40.5768 33.8278 40.764 33.5186 40.8975C33.2093 41.0309 32.8545 41.0977 32.4541 41.0977C32.0537 41.0977 31.6973 41.0309 31.3848 40.8975C31.0755 40.764 30.8135 40.5768 30.5986 40.3359C30.387 40.0918 30.2259 39.807 30.1152 39.4814C30.0046 39.1527 29.9492 38.7962 29.9492 38.4121ZM31.3555 38.3096V38.4121C31.3555 38.6335 31.375 38.8402 31.4141 39.0322C31.4531 39.2243 31.515 39.3936 31.5996 39.54C31.6875 39.6833 31.8014 39.7956 31.9414 39.877C32.0814 39.9583 32.2523 39.999 32.4541 39.999C32.6494 39.999 32.8171 39.9583 32.957 39.877C33.097 39.7956 33.2093 39.6833 33.2939 39.54C33.3786 39.3936 33.4404 39.2243 33.4795 39.0322C33.5218 38.8402 33.543 38.6335 33.543 38.4121V38.3096C33.543 38.0947 33.5218 37.8929 33.4795 37.7041C33.4404 37.512 33.377 37.3428 33.2891 37.1963C33.2044 37.0465 33.0921 36.9294 32.9521 36.8447C32.8122 36.7601 32.6429 36.7178 32.4443 36.7178C32.2458 36.7178 32.0765 36.7601 31.9365 36.8447C31.7998 36.9294 31.6875 37.0465 31.5996 37.1963C31.515 37.3428 31.4531 37.512 31.4141 37.7041C31.375 37.8929 31.3555 38.0947 31.3555 38.3096ZM38.6748 39.54C38.6748 39.4391 38.6455 39.348 38.5869 39.2666C38.5283 39.1852 38.4193 39.1104 38.2598 39.042C38.1035 38.9704 37.8773 38.9053 37.5811 38.8467C37.3141 38.7881 37.0651 38.7148 36.834 38.627C36.6061 38.5358 36.4076 38.4268 36.2383 38.2998C36.0723 38.1729 35.9421 38.0231 35.8477 37.8506C35.7533 37.6748 35.7061 37.4746 35.7061 37.25C35.7061 37.0286 35.7533 36.8203 35.8477 36.625C35.9453 36.4297 36.0837 36.2572 36.2627 36.1074C36.445 35.9544 36.6663 35.8356 36.9268 35.751C37.1904 35.6631 37.4867 35.6191 37.8154 35.6191C38.2744 35.6191 38.6683 35.6924 38.9971 35.8389C39.3291 35.9854 39.583 36.1872 39.7588 36.4443C39.9378 36.6982 40.0273 36.988 40.0273 37.3135H38.6211C38.6211 37.1768 38.5918 37.0547 38.5332 36.9473C38.4779 36.8366 38.39 36.7503 38.2695 36.6885C38.1523 36.6234 37.9993 36.5908 37.8105 36.5908C37.6543 36.5908 37.5192 36.6185 37.4053 36.6738C37.2913 36.7259 37.2035 36.7975 37.1416 36.8887C37.083 36.9766 37.0537 37.0742 37.0537 37.1816C37.0537 37.263 37.07 37.3363 37.1025 37.4014C37.1383 37.4632 37.1953 37.5202 37.2734 37.5723C37.3516 37.6243 37.4525 37.6732 37.5762 37.7188C37.7031 37.7611 37.8594 37.8001 38.0449 37.8359C38.4258 37.9141 38.766 38.0166 39.0654 38.1436C39.3649 38.2673 39.6025 38.4365 39.7783 38.6514C39.9541 38.863 40.042 39.1413 40.042 39.4863C40.042 39.7207 39.9899 39.9355 39.8857 40.1309C39.7816 40.3262 39.6318 40.4971 39.4365 40.6436C39.2412 40.7868 39.0068 40.8991 38.7334 40.9805C38.4632 41.0586 38.1589 41.0977 37.8203 41.0977C37.3288 41.0977 36.9121 41.0098 36.5703 40.834C36.2318 40.6582 35.9746 40.4352 35.7988 40.165C35.6263 39.8916 35.54 39.6117 35.54 39.3252H36.873C36.8796 39.5173 36.9284 39.6719 37.0195 39.7891C37.1139 39.9062 37.2327 39.9909 37.376 40.043C37.5225 40.0951 37.6803 40.1211 37.8496 40.1211C38.0319 40.1211 38.1833 40.0967 38.3037 40.0479C38.4242 39.9958 38.5153 39.9274 38.5771 39.8428C38.6423 39.7549 38.6748 39.654 38.6748 39.54ZM43.3867 41.0977C42.9766 41.0977 42.6087 41.0326 42.2832 40.9023C41.9577 40.7689 41.681 40.585 41.4531 40.3506C41.2285 40.1162 41.056 39.8444 40.9355 39.5352C40.8151 39.2227 40.7549 38.8906 40.7549 38.5391V38.3438C40.7549 37.9434 40.8118 37.5771 40.9258 37.2451C41.0397 36.9131 41.2025 36.625 41.4141 36.3809C41.6289 36.1367 41.8893 35.9495 42.1953 35.8193C42.5013 35.6859 42.8464 35.6191 43.2305 35.6191C43.6048 35.6191 43.9368 35.681 44.2266 35.8047C44.5163 35.9284 44.7588 36.1042 44.9541 36.332C45.1527 36.5599 45.3024 36.8333 45.4033 37.1523C45.5042 37.4681 45.5547 37.8197 45.5547 38.207V38.793H41.3555V37.8555H44.1729V37.748C44.1729 37.5527 44.137 37.3786 44.0654 37.2256C43.9971 37.0693 43.8929 36.9456 43.7529 36.8545C43.613 36.7633 43.4339 36.7178 43.2158 36.7178C43.0303 36.7178 42.8708 36.7585 42.7373 36.8398C42.6038 36.9212 42.4948 37.0352 42.4102 37.1816C42.3288 37.3281 42.2669 37.5007 42.2246 37.6992C42.1855 37.8945 42.166 38.1094 42.166 38.3438V38.5391C42.166 38.7507 42.1953 38.946 42.2539 39.125C42.3158 39.304 42.402 39.4587 42.5127 39.5889C42.6266 39.7191 42.7633 39.82 42.9229 39.8916C43.0856 39.9632 43.2695 39.999 43.4746 39.999C43.7285 39.999 43.9645 39.9502 44.1826 39.8525C44.404 39.7516 44.5944 39.6003 44.7539 39.3984L45.4375 40.1406C45.3268 40.3001 45.1755 40.4531 44.9834 40.5996C44.7946 40.7461 44.5667 40.8665 44.2998 40.9609C44.0329 41.0521 43.7285 41.0977 43.3867 41.0977Z"
        //           fill={enableCalculatorButton ? "#0072BC" : "#dddddd"}
        //         />
        //         <g clip-path="url(#clip0_848_9)">
        //           <path
        //             d="M12.75 30.322H25.8125C25.125 29.5166 24.375 29.0001 24.375 27.072C24.375 25.144 31 19.0001 32 20.0001V5.57202C32 4.84268 31.7103 4.1432 31.1945 3.62748C30.6788 3.11175 29.9793 2.82202 29.25 2.82202H12.75C12.0207 2.82202 11.3212 3.11175 10.8055 3.62748C10.2897 4.1432 10 4.84268 10 5.57202V27.572C10 28.3014 10.2897 29.0008 10.8055 29.5166C11.3212 30.0323 12.0207 30.322 12.75 30.322ZM16.875 26.197H14.125V23.447H16.875V26.197ZM16.875 20.697H14.125V17.947H16.875V20.697ZM16.875 15.197H14.125V12.447H16.875V15.197ZM22.375 26.197H19.625V23.447H22.375V26.197ZM22.375 20.697H19.625V17.947H22.375V20.697ZM22.375 15.197H19.625V12.447H22.375V15.197ZM27.875 22.0337L25.125 25.0001V17.947H27.875V22.0337ZM27.875 15.197H25.125V12.447H27.875V15.197ZM12.75 5.57202H29.25V9.69702H12.75V5.57202Z"
        //             fill={enableCalculatorButton ? "#0072BC" : "#dddddd"}
        //           />
        //           <path
        //             d="M33.4501 22.0417C32.8667 21.4584 32.1084 21.1667 31.4084 21.1667C30.7084 21.1667 29.8917 21.4584 29.3667 22.0417L25.9834 25.3084C24.8167 26.4751 24.8167 28.2834 25.9834 29.4501C27.1501 30.6167 28.9584 30.6167 30.1251 29.4501L33.4501 26.1251C34.5584 25.0167 34.5584 23.1501 33.4501 22.0417ZM32.6334 25.3084L31.0001 26.9417L28.9001 24.9001L26.3334 27.4667C26.3334 27.0001 26.4501 26.4751 26.8584 26.1251L30.1834 22.8001C30.4751 22.5084 30.9417 22.3334 31.3501 22.3334C31.7584 22.3334 32.2251 22.5084 32.5751 22.8001C33.2751 23.5584 33.2751 24.6084 32.6334 25.3084ZM35.4334 24.1417C35.4334 24.6084 35.3167 25.0167 35.2001 25.4834C35.7834 26.1834 35.7834 27.2334 35.1417 27.8751L33.5084 29.5084L32.6334 28.6334L31.0001 30.2667C30.2417 31.0251 29.1917 31.4334 28.2001 31.4334C28.3167 31.6084 28.4334 31.7834 28.6084 31.9584C29.7751 33.1251 31.5834 33.1251 32.7501 31.9584L36.0751 28.6334C37.2417 27.4667 37.2417 25.6584 36.0751 24.4917C35.7834 24.3751 35.6084 24.2584 35.4334 24.1417Z"
        //             fill={enableCalculatorButton ? "#0072BC" : "#dddddd"}
        //           />
        //         </g>
        //         <defs>
        //           <clipPath id="clip0_848_9">
        //             <rect width="33" height="33" fill="white" transform="translate(8)" />
        //           </clipPath>
        //         </defs>
        //       </svg>
        //     </div>
        //   )
        // }
        clearDrugOrderForm={handleClearDrugOrderForm}
        drugPrn={props.drugPrn}
        ChangeDrugPrn={(e: any) => props.setProp("drugPrn", e.target.value)}
        // drugDose={props.drugDose}
        // doseUp={() => {
        //   props.controller.setState({
        //     drugDose: (props.drugDose
        //       ? parseInt(props.drugDose) + 1
        //       : 1
        //     ).toString(),
        //   });
        // }}
        // drugQty={props.drugQty}
        // changeDrugQty={(e: any) =>
        //   // Todo: validate number
        //   props.onEvent({
        //     message: "HandleChangeDrugOrderDetail",
        //     params: {
        //       key: "drugQty",
        //       value: e.target.value,
        //       card: CARD_DRUG_ORDER,
        //       orderType,
        //     },
        //   })
        // }
        // drugDuration={props.drugDuration}
        // drugDescription={props.drugDescription}
        // changeDrugDuration={(e: any) =>
        //   props.onEvent({
        //     message: "HandleChangeDrugOrderDetail",
        //     params: {
        //       key: "drugDuration",
        //       value: e.target.value,
        //       card: CARD_DRUG_ORDER,
        //       orderType,
        //     },
        //   })
        // }
        // changeDrugDescription={(e: any) =>
        //   props.onEvent({
        //     message: "HandleChangeDrugOrderDetail",
        //     params: {
        //       key: "drugDescription",
        //       value: e.target.value,
        //       card: CARD_DRUG_ORDER,
        //     },
        //   })
        // }
        // drugUnits={props.DrugSelectSequence?.drugUnits || []}
        // selectedDrugUnitId={props.DrugSelectSequence?.selectedDrugUnitId}
        enabledButtonDispense={props.DrugSelectSequence?.is_dispensed}
        onClickDispense={() => setOpenModDispense(true)}
        // changeDrugUnit={(e: any, data: any) =>
        //   props.onEvent({
        //     message: "HandleChangeDrugOrderDetail",
        //     params: {
        //       key: "selectedDrugUnitId",
        //       value: data.value,
        //       stateKey: "DrugSelectSequence",
        //       card: CARD_DRUG_ORDER,
        //       orderType,
        //     },
        //   })
        // }
        // drugRoutes={props.DrugSelectSequence?.drugRoutes || []}
        // selectedDrugRouteId={props.DrugSelectSequence?.selectedDrugRouteId}
        // changeDrugRoute={(e: any, data: any) =>
        //   props.controller.setState({
        //     DrugSelectSequence: {
        //       ...props.DrugSelectSequence,
        //       selectedDrugRouteId: data.value,
        //     },
        //   })
        // }
        // drugSites={props.DrugSelectSequence?.drugSites || []}
        // selectedDrugSiteId={props.DrugSelectSequence?.selectedDrugSiteId}
        // changeDrugSite={(e: any, data: any) =>
        //   props.controller.setState({
        //     DrugSelectSequence: {
        //       ...props.DrugSelectSequence,
        //       selectedDrugSiteId: data.value,
        //     },
        //   })
        // }
        // drugFrequencies={props.DrugSelectSequence?.drugFrequencies || []}
        // selectedDrugFrequencyId={props.DrugSelectSequence?.selectedDrugFrequencyId}
        // hideDrugDescription={hideDrugDescription}
        // changeDrugFrequency={(e: any, data: any) =>
        //   props.onEvent({
        //     message: "HandleChangeDrugOrderDetail",
        //     params: {
        //       key: "selectedDrugFrequencyId",
        //       value: data.value,
        //       stateKey: "DrugSelectSequence",
        //       card: CARD_DRUG_ORDER,
        //       orderType,
        //     },
        //   })
        // }
        // drugMethods={props.DrugSelectSequence?.drugMethods || []}
        // selectedDrugMethodId={props.DrugSelectSequence?.selectedDrugMethodId}
        // changeDrugMethod={(e: any, data: any) =>
        //   props.controller.setState({
        //     DrugSelectSequence: {
        //       ...props.DrugSelectSequence,
        //       selectedDrugMethodId: data.value,
        //     },
        //   })
        // }
        // order div
        onChangeDivision={(e: any, v: any) => props.setProp("drugOrder.order_div", v.value)}
        orderDiv={props.drugOrder?.order_div || ""}
        telepharType={props.drugOrder?.telephar_type || ""}
        onChangeTelepharType={handleChangeTelepharType}
        showTelepharType={orderType === "HOME_OPD" && config.ENABLE_INTRA_TELEPHAR}
        divisionOptions={divisionOptions}
        showToolBox={true}
        // Add to Order
        addToOrder={handleAddToOrder}
        // Order Items
        // drugOrderItems={renderDrugOrderItems}
        hasFactSheet={!!Object.keys(props.selectedDrug?.original?.factsheet_data || {}).length}
        doctorNote={props.drugOrder?.doctor_note}
        onChangeDoctorNote={(e: any, v: any) => props.setProp("drugOrder.doctor_note", v.value)}
        // selectedDrug to edit
        // drugItemsTrProps={handleDrugItemsTrProps}
        // drug order set
        onClickOrderset={(e: any) => {
          props.runSequence({ sequence: "DrugOrderTemplate", restart: true });
        }}
        onClickREMED={(e: any) => {
          props.onEvent({
            message: "HandleReMedication",
            params: { action: "open", card: CARD_DRUG_ORDER_ID },
          });
        }}
        onClickDrugHistory={handleClickDrugHistory}
        // Confirm order
        confirmOrder={() => handleConfirmOrder()}
        // SolventSelectionConfig
        // onOpenModSolventSelection={handleOpenModSolventSelection}
        modSolventSelectionConfig={props.modSolventSelectionConfig}
        disabledConfirmedOrderBtn={true}
        readOnlyDuration={orderType?.includes("ONE") || orderType?.includes("STAT")}
        noRequiredDuration={[
          "ONE_DAY_IPD",
          "STAT_OPD",
          "STAT_IPD",
          "ONE_DOSE_IPD",
          "ONE_DOSE_OPD",
        ].includes(orderType || "")}
        // component
        // doseInput={
        //   <Input
        //     disabled={!props.selectedDrug}
        //     fluid={true}
        //     id="txt-drugDose"
        //     onChange={handleChangeDrugDose}
        //     onBlur={handleBlurDrugDose}
        //     style={{ opacity: 1 }}
        //     type="number"
        //     value={props.drugDose ? props.drugDose : ""}
        //   ></Input>
        // }
        cardEditMedOrder={
          <>
            {showOutsideDrug && (
              <Checkbox
                checked={isOutsideDrug}
                label={props.languageUX === "en" ? "Outside hospital drug" : "สั่งยานอก รพ."}
                style={{ marginLeft: "0.75rem", paddingTop: "1rem" }}
                onChange={(e, data) => setIsOutsideDrug(!!data.checked)}
              />
            )}
            <CardEditMedOrder
              onEvent={props.onEvent}
              setProp={props.setProp}
              DrugSelectSequence={props.DrugSelectSequence}
              drugDose={props.drugDose}
              drugDuration={props.drugDuration}
              drugOrder={props.drugOrder}
              drugPermission={props.drugPermission}
              drugPrn={props.drugPrn}
              drugQty={props.drugQty}
              modSolventSelectionConfig={props.modSolventSelectionConfig}
              orderType={orderType}
              orderTypeTab={orderTypeTab}
              openCalculator={openCalCulator}
              pediatricData={props.pediatricData}
              selectedAppointment={props.selectedAppointment}
              statusRequested={statusRequested}
              masterOptions={props.masterOptions}
              masterData={props.masterData}
              onAddToOrder={handleAddToOrder}
              drugSearchLoading={props.drugSearchLoading}
              drugSearchResult={props.drugSearchResult}
              drugSearchText={props.drugSearchText}
              selectedDrug={props.selectedDrug}
              drugDescription={props.drugDescription}
              searchedItemListWithKey={props.searchedItemListWithKey}
              setOpenCalculator={setOpenCalculator}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              hideDisplayData={typeof props.modSolventSelectionConfig?.admixtureIndex === "number"}
              isOutsideDrug={showOutsideDrug && isOutsideDrug}
              languageUX={props.languageUX}
            />
          </>
        }
        languageUX={props.languageUX}
        componentDrugVerbalOrder={
          <CardDrugVerbalOrder
            setProp={props.setProp}
            drugVerbalFreeTxt={props.drugVerbalFreeTxt}
          />
        }
      />

      <ModAuthen
        titleName={intl.formatMessage({ id: "ยืนยันการตรวจสอบ" })}
        titleColor={"blue"}
        open={openModAuthen?.open}
        onDeny={() => setOpenModAuthen({ open: false, isApproveOrder: false })}
        error={props.authenError}
        onApprove={({ username, password }: any) => {
          // save
          if (openModAuthen?.isApproveOrder) {
            handleApproveOrder({
              approved_by_username: username,
              approved_by_password: password,
              isCardRejectOrder: props.isCardRejectOrder,
            });
          } else {
            handleConfirmOrder({
              approved_by_username: username,
              approved_by_password: password,
              isCardRejectOrder: props.isCardRejectOrder,
            });
          }
          // setOpenModAuthen({ open: false, isApproveOrder: false });
        }}
      />

      <ModMedReconcileAlert
        onEvent={props.onEvent}
        setProp={props.setProp}
        django={props.django}
        medReconcileCheck={props.medReconcileCheck}
        medReconcileIndex={props.medReconcileIndex}
        open={props.medReconcileCheck?.open_card_med_reconciliation}
        languageUX={props.languageUX}
      />

      <ModCheckADR
        DrugSelectSequence={props.DrugSelectSequence}
        onEvent={props.onEvent}
        setProp={props.setProp}
        errorMessage={props.errorMessage}
        card={CARD_DRUG_ORDER_ID}
        masterOptions={props.masterOptions}
        orderType={orderTypeTab}
        languageUX={props.languageUX}
      />

      <ModInfo
        open={modSaveWeightWarn || modPediatricDoseErr}
        titleColor={"red"}
        titleName={intl.formatMessage({ id: "แจ้งเตือน" })}
        onApprove={() => {
          if (modSaveWeightWarn) {
            props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
            setModSaveWeightWarn(false);
            props.setProp("goToMenu", "Vital Sign");
            props.setProp("pediatricData", null);
          }

          setModPediatricDoseErr(false);
          props.setProp("errorMessage.ModPediatricDose.error", null);
        }}
        onClose={() => {
          if (modSaveWeightWarn) {
            props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
            setModSaveWeightWarn(false);
            props.setProp("goToMenu", "Vital Sign");
            props.setProp("pediatricData", null);
          }
          setModPediatricDoseErr(false);
          props.setProp("errorMessage.ModPediatricDose.error", null);
        }}
      >
        {props.errorMessage?.ModPediatricDose?.error === "string" ? (
          <div>{props.errorMessage?.ModPediatricDose?.error}</div>
        ) : (
          <ErrorMessage error={props.errorMessage?.ModPediatricDose?.error} />
        )}

        {modSaveWeightWarn ? (
          <div>{intl.formatMessage({ id: "กรุณาบันทึกน้ำหนักตัวของผู้ป่วยก่อนสั่งยา" })}</div>
        ) : (
          <></>
        )}
      </ModInfo>

      <ModInfo
        open={!!props.errorMessage?.ModQAClaimAlert?.error}
        titleColor={"red"}
        style={{ minWidth: "30rem" }}
        titleName={intl.formatMessage({ id: "แจ้งเตือน" })}
        onApprove={() => {
          props.setProp("errorMessage.ModQAClaimAlert", null);
        }}
        onClose={() => {
          props.setProp("errorMessage.ModQAClaimAlert", null);
        }}
      >
        <div style={{ textAlign: "left" }}>
          <div style={{ margin: "1.5rem 0 1rem" }}>
            ตรวจพบรายการยาที่ไม่มีการตอบคำถาม NED ตามรายการนี้
          </div>
          {(props.errorMessage?.ModQAClaimAlert?.drugNames ?? []).map(
            (name: string, index: number) => (
              <div key={`drug-qa-claim-${index}`} style={{ paddingLeft: "0.5rem" }}>
                {index + 1}. {name}
              </div>
            ),
          )}
          <div style={{ display: "flex", margin: "1rem 0 1rem", gap: "0.75rem" }}>
            <label>โปรดระบุคำตอบ โดยกดเลือกที่สัญลักษณ์</label>
            <QAStatus item={{ claim_result: 2 }} />
          </div>
        </div>
      </ModInfo>

      <Modal size="tiny" open={!!props.DrugSelectSequence?.diFeedback}>
        <ModCheckDI
          diDetail={(props.DrugSelectSequence?.diItems || []).map((item: any, index: number) => (
            <div key={index} style={{ padding: "5px" }}>
              <div>{item.description}</div>
              {item.members_name.map((member_name: string, member_index: number) => (
                <div key={member_index}>{`${member_index}. ${member_name}`}</div>
              ))}
            </div>
          ))}
          needNote={!props.DrugSelectSequence?.diLock}
          acknowledge={() => {
            props.onEvent({
              message: "RunSequence",
              params: { sequence: "DrugSelect", feedback: "acknowledge", orderType: orderTypeTab },
            });
          }}
          confirmOrder={() => {
            props.onEvent({
              message: "RunSequence",
              params: { sequence: "DrugSelect", feedback: "confirm", orderType: orderTypeTab },
            });
          }}
          cancelOrder={() => {
            props.onEvent({
              message: "RunSequence",
              params: { sequence: "DrugSelect", feedback: "cancel" },
            });
          }}
          changeNote={(e: any) => {
            props.setProp("DrugSelectSequence.confirmDINote", e.target.value);
          }}
          languageUX={props.languageUX}
        />
      </Modal>

      <Modal open={props.modDoctorCertificate?.open} size="small">
        <ModCheckDoctorCertificateUX
          hideInput={BYPASS_DOCTOR_CERT_KEYING} // Feature 68144
          narcoticTypeDetail={htmlParse(props.modDoctorCertificate?.narcoticDrugType || "")}
          doctorCertificate={props.modDoctorCertificate?.doctorCertificate}
          onInputChange={(e: any, v: any) => {
            props.setProp("modDoctorCertificate.doctorCertificate", v.value);
          }}
          onApprove={() => {
            props.onEvent({
              message: "HandleCheckDoctorCertificate",
              params: {
                orderType: orderTypeTab,
                approvalCallBack: props.onCertificateApprove ? props.onCertificateApprove : null,
                card: CARD_DRUG_ORDER_ID,
                cardKey: CARD_DRUG_ORDER,
                action: "SAVE",
                skipChecking: BYPASS_DOCTOR_CERT_KEYING,
              },
            });
          }}
          onCancel={() => {
            props.setProp("modDoctorCertificate.open", false);

            props.setProp(
              `buttonLoadCheck.${props.modDoctorCertificate.card}_${props.modDoctorCertificate.action}`,
              "",
            );

            props.setProp(`loadingStatus.${props.modDoctorCertificate.card}`, false);
          }}
          languageUX={props.languageUX}
        />
      </Modal>

      {/* drug-lab interaction */}
      <Modal open={props.modDrugLabInteraction?.open} closeOnDimmerClick={false}>
        <ModDrugLabInteraction
          // main function
          runSequence={props.runSequence}
          setProp={props.setProp}
          onEvent={props.onEvent}
          // data
          modDrugLabInteraction={props.modDrugLabInteraction}
          isEditable={true}
          orderType={orderTypeTab}
          languageUX={props.languageUX}
          masterOptions={props.masterOptions}
        />
      </Modal>

      {/* drug-disease */}
      <Modal open={props.modDrugDisease?.open} closeOnDimmerClick={false}>
        <ModDrugDisease
          // main function
          runSequence={props.runSequence}
          setProp={props.setProp}
          onEvent={props.onEvent}
          // data
          modDrugDisease={props.modDrugDisease}
          isEditable={true}
          orderType={orderTypeTab}
          languageUX={props.languageUX}
          masterOptions={props.masterOptions}
        />
      </Modal>

      {/* drug-interaction */}
      <Modal open={props.modDrugInteraction?.open} closeOnDimmerClick={false}>
        <ModDrugInteraction
          onEvent={props.onEvent}
          setProp={props.setProp}
          // main function
          runSequence={props.runSequence}
          isEditable={true}
          languageUX={props.languageUX}
          // data
          modDrugInteraction={props.modDrugInteraction}
          masterOptions={props.masterOptions}
          drugVerbalOrder={!props.hideCardDrugVerbalOrder}
        />
      </Modal>

      <Modal
        open={props.modDoctorCertificate?.openModConfirm}
        style={{ height: "auto", width: "300px" }}
      >
        <ModCertificateErrorUX
          onConfirm={() => {
            props.setProp("modDoctorCertificate.openModConfirm", false);
          }}
          languageUX={props.languageUX}
        />
      </Modal>

      {/* SolventSelection */}
      {/* <Modal
        closeIcon
        open={props.modSolventSelectionConfig?.openModal}
        closeOnDimmerClick={true}
        onClose={handleCloseModSolventSelection}
      >
        <ModSolventSelection
          // function
          onEvent={props.onEvent}
          setProp={props.setProp}
          // permission
          drugPermission={props.drugPermission}
          // CommonInterface
          errorMessage={props.errorMessage}
          successMessage={props.successMessage}
          // seq
          DrugSelectSequence={props.DrugSelectSequence}
          // Master
          drugUnits={props.DrugSelectSequence?.drugUnits || []}
          // selected data
          selectedDrug={props.selectedDrug}
          // data
          drugOrderType={orderType}
          modSolventSelectionConfig={props.modSolventSelectionConfig}
        />
      </Modal> */}

      {(props.errorMessage?.[CARD_DUPLICATE_REASON]?.error?.code === "DUPLICATE_DRUG_ORDERS" ||
        props.errorMessage?.[CARD_REJECT_ORDER]?.error?.code === "DUPLICATE_DRUG_ORDERS") && (
        <CardDuplicateDrugOrders
          duplicateReasonsOptions={props.duplicateReasonsOptions}
          duplicateList={
            props.errorMessage?.[CARD_DUPLICATE_REASON]?.error?.duplicate_list ||
            props.errorMessage?.[CARD_REJECT_ORDER]?.error?.duplicate_list
          }
          onClose={() => {
            props.setProp("errorMessage", {
              ...props.errorMessage,
              [CARD_DUPLICATE_REASON]: null,
              [CARD_REJECT_ORDER]: null,
              [`${CARD_DRUG_ORDER}_CONFIRM`]: null,
            });

            props.setProp("buttonLoadCheck", {
              ...props.errorMessage,
              [`${CARD_DRUG_ORDER}_CONFIRM`]: null,
            });
          }}
          onApprove={handleApproveDuplicateDrug}
          languageUX={props.languageUX}
        />
      )}

      <ModDrugOrderTemplate
        runSequence={props.runSequence}
        DrugOrderTemplateSequence={props.DrugOrderTemplateSequence}
        currentDoctor={props.currentDoctor}
        card={CARD_DRUG_ORDER}
        orderType={orderType}
        languageUX={props.languageUX}
      />

      <Modal open={props.modReMedication?.open}>
        <ModReMedicationUX
          onSearchReMED={() => {
            props.onEvent({
              message: "HandleReMedication",
              params: { action: "search", card: CARD_DRUG_ORDER_ID },
            });
          }}
          doctorSearchBox={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                style={{ marginRight: "5px" }}
                checked={props.modReMedication?.checkedDoctor}
                onChange={(e: any, { checked }) => {
                  props.setProp("modReMedication", {
                    ...props.modReMedication,
                    checkedDoctor: checked,
                    doctor: null,
                  });
                }}
              />
              <SearchBox
                // vertical={true}
                disabled={!props.modReMedication?.checkedDoctor}
                onEvent={props.onEvent}
                setProp={props.setProp}
                searchedItemList={props.searchedItemList}
                selectedItem={props.modReMedication?.doctor}
                setSelectedItem={(item: any) => {
                  props.setProp("modReMedication.doctor", item);
                }}
                type="Doctor"
                label={intl.formatMessage({ id: "แพทย์" })}
                toDisplay={(item: any) => `${item.name_code}`}
                fluid={true}
                style={{ width: "100%" }}
              />
            </div>
          }
          divisionSearchBox={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                style={{ marginRight: "5px" }}
                checked={props.modReMedication?.checkedDivision}
                onChange={(e: any, { checked }) => {
                  props.setProp("modReMedication", {
                    ...props.modReMedication,
                    checkedDivision: checked,
                    division: null,
                  });
                }}
              />
              <SearchBox
                // vertical={true}
                disabled={!props.modReMedication?.checkedDivision}
                onEvent={props.onEvent}
                setProp={props.setProp}
                searchedItemList={props.searchedItemList}
                selectedItem={props.modReMedication?.division}
                setSelectedItem={(item: any) => {
                  props.setProp("modReMedication.division", item);
                }}
                type="Division"
                label={intl.formatMessage({ id: "แผนก" })}
                // placeholder="กรอกชื่อผู้จ่ายเงินที่ต้องการค้นหา"
                toDisplay={(item: any) => `${item.name_code}`}
                fluid={true}
                style={{ width: "100%" }}
              />
            </div>
          }
          remedData={remedList}
          onClickAddToOrder={() => {
            props.onEvent({
              message: "HandleReMedication",
              params: {
                action: "add_to_order",
                card: CARD_DRUG_ORDER_ID,
                orderType,
              },
            });
          }}
          onClickCancel={() => {
            props.onEvent({
              message: "HandleReMedication",
              params: { action: "close", card: CARD_DRUG_ORDER_ID },
            });
          }}
          languageUX={props.languageUX}
        />
      </Modal>

      {/* Recontinue Medication */}
      <Modal open={props.modRecontinueMed?.open} size="large">
        <ModRecontinueMed
          // main function
          onEvent={props.onEvent}
          card={CARD_DRUG_ORDER}
          // data
          modRecontinueMed={props.modRecontinueMed}
          searchedItemListWithKey={props.searchedItemListWithKey}
          orderType={orderType}
          languageUX={props.languageUX}
        />
      </Modal>

      <Modal
        open={openModDrugHistory}
        style={{
          width: "85%",
        }}
        closeIcon={true}
        closeOnDimmerClick={true}
        onClose={handleCloseModDrugHistory}
      >
        <div style={{ maxHeight: "93vh", overflowY: "auto", padding: "1rem" }}>
          <CardDrugOrderHistory
            isDrugOrderHistory={true}
            frezzeRecordViewIndex={true}
            DrugOrderHistorySequence={props.DrugOrderHistorySequence}
            drugHistoryList={props.drugHistoryList}
            drugHistoryOrderList={props.drugHistoryOrderList}
            controller={props.drugOrderHistoryController}
            runSequence={props.runSequence}
            onEvent={props.onEvent}
            setProp={props.setProp}
            selectedEncounter={props.selectedEncounter}
            selectedEmr={props.selectedEmr}
            masterOptions={props.masterOptions}
            masterData={props.masterData}
            errorMessage={props.errorMessage}
            loadingStatus={props.loadingStatus}
            successMessage={props.successMessage}
            selectedDivision={props.selectedDivision}
            searchedItemListWithKey={props.searchedItemListWithKey}
            // config
            addToOrderMode={true}
            // callback
            onAddToOrder={handleDrugHistoryAddToOrder}
            type={"PATIENT_HISTORY"} // for flag selectEncounter in function SelectDrugOrderWorking
            languageUX={props.languageUX}
          />
        </div>
      </Modal>

      <ModConfirmDelete
        open={props.modConfirmDeleteDrug?.open}
        titleName={intl.formatMessage({ id: "ต้องการลบรายการยาหรือไม่" })}
        size="mini"
        buttonRightColor="red"
        buttonRight={intl.formatMessage({ id: "ยกเลิก" })}
        buttonLeftColor="green"
        buttonLeft={intl.formatMessage({ id: "ตกลง" })}
        onButtonLeftClick={() => {
          props.onEvent({
            message: "HandleOnRemoveDrug",
            params: {
              action: "confirm",
              removeDrugId: props.modConfirmDeleteDrug.product,
              drugIndex: props.modConfirmDeleteDrug.index,
            },
          });
        }}
        onButtonRightClick={() => {
          props.setProp("modConfirmDeleteDrug.open", false);
        }}
        titleColor={"yellow"}
      />

      <ModDrugAllVerify
        onEvent={props.onEvent}
        setProp={props.setProp}
        // data
        modAllVerifyDrug={props.modAllVerifyDrug}
        languageUX={props.languageUX}
      />

      <ModDrugDuplicateGroup
        // data
        modDuplicateDrug={props.modDuplicateDrug}
        onClose={() => props.setProp("modDuplicateDrug", null)}
        onApprove={handleConfirmDrugGroupDuplicateWithReason}
        // options
        duplicateReasonsOptions={props.duplicateReasonsOptions}
        languageUX={props.languageUX}
      />

      {/* #<SnackMessage
        onEvent={props.onEvent}
        onClose={() => {
          props.setProp(
            `errorMessage.${CARD_DRUG_ORDER_ID}.showMessage`,
            false
          );
        }}
        error={props.errorMessage?.[CARD_DRUG_ORDER_ID]?.error}
        success={props.successMessage?.[CARD_DRUG_ORDER_ID]}
      /> */}

      <SnackMessage
        onEvent={props.onEvent}
        onClose={handleCloseDrugOrderMessage}
        error={drugOrderErrorMessage.error}
        header={drugOrderErrorMessage.header}
        success={props.successMessage?.[CARD_DRUG_ORDER]}
        languageUX={props.languageUX}
      />

      <SnackMessage
        onEvent={props.onEvent}
        error={props.errorMessage?.[MOD_SOLVENT_SELECTION_ID]}
        success={null}
        onClose={() => {
          props.setProp(`errorMessage.${MOD_SOLVENT_SELECTION_ID}`, null);
        }}
        languageUX={props.languageUX}
      />

      {props.errorMessage?.[CARD_DUPLICATE_REASON]?.error?.code !== "DUPLICATE_DRUG_ORDERS" &&
        props.errorMessage?.[CARD_DUPLICATE_REASON]?.error && (
          <SnackMessage
            onEvent={props.onEvent}
            onClose={() => {
              props.setProp(`errorMessage.${CARD_DUPLICATE_REASON}`, null);
            }}
            error={duplicateReasonErrorMessage.error}
            header={duplicateReasonErrorMessage.header}
            success={null}
            languageUX={props.languageUX}
          />
        )}

      {props.errorMessage?.[CARD_DUPLICATE_CLASSIFICATION_REASON] && (
        <CardDuplicateDrugClassificationOrders
          // function
          onClose={() =>
            props.setProp("errorMessage", {
              ...props.errorMessage,
              [CARD_DUPLICATE_CLASSIFICATION_REASON]: null,
            })
          }
          onApprove={handleConfirmDrugDuplicateWithReason}
          // options
          duplicateReasonsOptions={props.duplicateReasonsOptions}
          // data
          duplicateList={props.errorMessage?.[CARD_DUPLICATE_CLASSIFICATION_REASON]}
          languageUX={props.languageUX}
        />
      )}

      {props.drugOrder?.estimate?.isAdd && (
        <CardDrugClaimQA
          estimate={props.drugOrder?.estimate || {}}
          orderType={orderType}
          selectedEncounter={props.selectedEncounter}
          selectedEmr={props.selectedEmr}
          selectedProgressCycle={props.selectedProgressCycle}
          onEvent={props.onEvent}
          languageUX={props.languageUX}
        />
      )}

      <ModDrugFact
        open={openModFactSheet}
        drugDetail={props.selectedDrug?.original}
        // callback
        onClose={() => setOpenModFactSheet(false)}
        languageUX={props.languageUX}
      />

      {/* Modal add note for confirm order with pharmacist */}
      <ModConfirmEditNote
        setProp={props.setProp}
        data={modPharmaConfirm}
        stateKey="openModPharmacistNote"
        options={props.masterOptions?.rxEditReason}
        onChange={setModPharmaConfirm}
        onConfirm={() => handleConfirmOrder()}
        onClose={() =>
          setModPharmaConfirm({
            open: false,
            note: "",
          })
        }
      />

      {/* Modal Med Reconcile Duplicate Drug */}
      <Modal open={modMRDuplicate?.open} closeOnDimmerClick={false} size="tiny">
        <Modal.Header style={{ backgroundColor: "#fbbd08", color: "white" }}>
          แจ้งเตือน
        </Modal.Header>
        <Modal.Content>
          <div>
            <div style={{ fontSize: "16px" }}>{htmlParse(modMRDuplicate?.message)}</div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "15px",
              }}
            >
              <Button
                inverted
                color="yellow"
                content={intl.formatMessage({ id: "ตกลง" })}
                onClick={() => {
                  setModMRDuplicate({ open: false, message: "" });
                }}
              />
            </div>
          </div>
        </Modal.Content>
      </Modal>

      <ModDescriptionUD
        open={!!modDrugDesc.open}
        description={modDrugDesc.desc}
        // config
        editable={true}
        // callback
        onApprove={handleConfirmDesc}
        onClose={handleCloseModDesc}
        languageUX={props.languageUX}
      />

      <ModProductPackageAlert
        // data
        items={props.drugPackageAlertList}
        type="drug"
        // callback
        onClose={handleCloseDrugPackageAlert}
        onAddToOrder={handlePackageAddToOrder}
        languageUX={props.languageUX}
      />

      <ModError
        open={props.errorMessage?.["CardDrugOrder_CONFIRM"]}
        titleColor="red"
        onApprove={() => {
          props.setProp(`errorMessage.${"CardDrugOrder_CONFIRM"}`, null);
        }}
        alertText={props.errorMessage?.["CardDrugOrder_CONFIRM"]?.error?.approved_by?.[0]}
      />

      <ModDrugDispensingOrder
        open={openModDispense}
        fullName={props.DrugSelectSequence?.full_name}
        unit={props.DrugSelectSequence?.dispense_unit}
        route={props.DrugSelectSequence?.default_route}
        frequency={props.DrugSelectSequence?.default_frequency}
        totalDispenseUnit={props.DrugSelectSequence?.total_dispense_unit}
        // options
        unitOptions={props.masterOptions?.unit || []}
        routeOptions={props.DrugSelectSequence?.drugRoutes || []}
        frequencyOptions={props.DrugSelectSequence?.drugFrequencies || []}
        // callback
        onClose={handleCloseModDispense}
        onSave={handleSaveDrugDispense}
        languageUX={props.languageUX}
      />

      <ModConfirm
        size="tiny"
        open={modAgeWarn !== ""}
        openModal={modAgeWarn !== ""}
        titleColor={"red"}
        titleName={intl.formatMessage({ id: "แจ้งเตือนสั่งยานอกช่วงอายุที่กำหนด" })}
        disabledApproveButton={!props.DrugSelectSequence?.note_limited_age}
        denyButtonColor="red"
        denyButtonText={
          props.selectedDrug?.original?.locked_if_age_is_outside_specified_range ? "" : "ยกเลิก"
        }
        disabledDenyButton={
          props.selectedDrug?.original?.locked_if_age_is_outside_specified_range ? true : false
        }
        approveButtonColor="green"
        approveButtonText={
          props.selectedDrug?.original?.locked_if_age_is_outside_specified_range
            ? "ปิดหน้าต่าง"
            : "ยืนยัน"
        }
        onApprove={() => {
          if (props.selectedDrug?.original?.locked_if_age_is_outside_specified_range) {
            props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
            setModSaveWeightWarn(false);
            props.setProp("pediatricData", null);
            setModAgeWarn("");
          } else {
            if (props.DrugSelectSequence?.note_limited_age) {
              setModAgeWarn("");
            }
          }
        }}
        onDeny={() => {
          setModAgeWarn("");
          props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
          setModSaveWeightWarn(false);
          props.setProp("pediatricData", null);
        }}
        onCloseWithDimmerClick={() => {
          setModAgeWarn("");
          props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
          setModSaveWeightWarn(false);
          props.setProp("pediatricData", null);
        }}
        onClose={() => {
          setModAgeWarn("");
          props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
          setModSaveWeightWarn(false);
          props.setProp("pediatricData", null);
        }}
        content={
          <>
            <div>
              {props.selectedDrug?.original?.locked_if_age_is_outside_specified_range ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  ไม่อนุญาตให้สั่งยารายการนี้
                </div>
              ) : (
                <></>
              )}
              {modAgeWarn ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    padding: "10px",
                  }}
                >
                  {modAgeWarn}
                </div>
              ) : (
                <></>
              )}
              <div>
                {" "}
                ช่วงอายุต่ำสุดที่แนะนำสำหรับใช้ยารายการนี้ คือ{" "}
                {props.selectedDrug?.original?.minimum_age_year} ปี{" "}
                {props.selectedDrug?.original?.minimum_age_month} เดือน{" "}
              </div>
              <div>
                {" "}
                ช่วงอายุสูงสุดที่แนะนำสำหรับใช้ยารายการนี้ คือ{" "}
                {props.selectedDrug?.original?.maximum_age_year} ปี{" "}
                {props.selectedDrug?.original?.maximum_age_month} เดือน{" "}
              </div>
            </div>
            {props.selectedDrug?.original?.locked_if_age_is_outside_specified_range ? (
              <></>
            ) : (
              <div style={{ paddingTop: "5px" }}>
                <Form>
                  <Form.Field
                    label={intl.formatMessage({ id: "กรุณาใส่เหตุผลสำหรับยืนยันการสั่งยา" })}
                  ></Form.Field>
                  <Form.Field>
                    <Dropdown
                      allowAdditions={true}
                      onAddItem={(e: any, v: any) => {
                        setReasonOptions([
                          { key: v.value, text: v.value, value: v.value },
                          ...reasonOptions,
                        ]);
                      }}
                      search={true}
                      fluid={true}
                      clearable={true}
                      selection={true}
                      options={reasonOptions || []}
                      value={props.DrugSelectSequence?.note_limited_age || ""}
                      onChange={(e: any, data: any) => {
                        props.setProp("DrugSelectSequence.note_limited_age", data.value);
                      }}
                      style={{ width: "100%" }}
                    />
                  </Form.Field>
                </Form>
              </div>
            )}
          </>
        }
      />

      <ModConfirm
        content={
          <div style={{ textAlign: "center", fontWeight: "bold", margin: "0.5rem 0 -0.5rem" }}>
            ยืนยันการลบ Solvent ที่สั่งคู่มากับยารายการนี้หรือไม่
          </div>
        }
        titleColor={"red"}
        titleName={"ข้อความแจ้งเตือน"}
        openModal={!!modConfirmUnlinkMixture}
        denyButtonText="ยกเลิก"
        approveButtonText="ยืนยัน"
        onApprove={handleConfirmUnlinkMixture}
        onCloseWithDimmerClick={handleCloseModUnlinkMixture}
        onDeny={handleCloseModUnlinkMixture}
      />

      <Modal
        open={openModEditDrug}
        size="large"
        onClose={() => {
          setOpenModEditDrug(false);

          handleClearDrugOrderForm();
        }}
      >
        <CardEditMedOrder
          onEvent={props.onEvent}
          setProp={props.setProp}
          DrugSelectSequence={props.DrugSelectSequence}
          drugDose={props.drugDose}
          drugDuration={props.drugDuration}
          drugOrder={props.drugOrder}
          drugPermission={props.drugPermission}
          drugPrn={props.drugPrn}
          drugQty={props.drugQty}
          modSolventSelectionConfig={props.modSolventSelectionConfig}
          orderType={orderType}
          orderTypeTab={orderTypeTab}
          openCalculator={openCalCulator}
          pediatricData={props.pediatricData}
          selectedAppointment={props.selectedAppointment}
          statusRequested={statusRequested}
          masterOptions={props.masterOptions}
          masterData={props.masterData}
          onAddToOrder={handleAddToOrder}
          drugSearchLoading={props.drugSearchLoading}
          drugSearchResult={props.drugSearchResult}
          drugSearchText={props.drugSearchText}
          selectedDrug={props.selectedDrug}
          drugDescription={props.drugDescription}
          searchedItemListWithKey={props.searchedItemListWithKey}
          setOpenCalculator={setOpenCalculator}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          showHeader={true}
          onClose={() => {
            setOpenModEditDrug(false);
          }}
          languageUX={props.languageUX}
        />
      </Modal>

      <ModConfirmCNMI
        titleName={intl.formatMessage({ id: "ไม่อนุญาตให้ส่งยารายการนี้ทางขนส่ง" })}
        openModal={!!props.DrugSelectSequence?.drugTransportNotAllowed?.length}
        titleColor="red"
        approveButtonText={intl.formatMessage({ id: "ยืนยันสั่ง และยกเลิก Home delivery" })}
        denyButtonText={intl.formatMessage({ id: "ไม่สั่ง" })}
        approveButtonStyle={{ minWidth: "max-content", marginLeft: "-1rem" }}
        denyButtonStyle={{ marginLeft: "1rem" }}
        modalStyle={{ minWidth: "40rem" }}
        content={
          <div style={{ textAlign: "center", margin: "-0.5rem 0 -1.25rem" }}>
            {(props.DrugSelectSequence?.drugTransportNotAllowed || []).map(
              (item: any, index: number) => (
                <div key={`drug-transport-${index}`}>
                  <div
                    style={{
                      textAlign: "left",
                      margin: "0 0 0.75rem 0",
                      ...(index > 0 && {
                        borderTop: "1px dashed rgba(34,36,38,.65)",
                        marginTop: "1rem",
                        paddingTop: "1rem",
                      }),
                    }}
                  >
                    <strong style={{ paddingLeft: "1rem" }}>
                      {index + 1}. {item.name}
                    </strong>
                  </div>
                  <strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.message,
                      }}
                    />
                  </strong>
                  <div style={{ marginTop: "0.75rem" }}>
                    {intl.formatMessage({ id: "หากยืนยันสั่งยานี้ ระบบจะยกเลิก Home delivery" })}
                  </div>
                  <div>
                    {intl.formatMessage({
                      id: "และใบสั่งยานี้จะเปลี่ยนเป็นใบสั่งยาที่ต้องรับยาในโรงพยาบาลเท่านั้น",
                    })}
                  </div>
                </div>
              ),
            )}
          </div>
        }
        onDeny={handleCloseModDrugTransport}
        // onCloseWithDimmerClick={handleCloseModDrugTransport}
        onApprove={handleApproveDrugTransport}
      />

      <ModConfirmEditNote
        setProp={props.setProp}
        data={props.openModPharmacistNote}
        stateKey="openModPharmacistNote"
        options={props.masterOptions?.rxEditReason}
        onConfirm={() => props.onSaveVerbalOrder?.()}
      />
    </div>
  );
};

export default React.memo(CardDrugOrder);
